import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AngularGridInstance, Formatters, GridOdataService, GridOption, FieldType } from 'angular-slickgrid';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MessageService } from '../message.service';
import { RestApiService } from '../rest-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SocketService } from '../socket.service';
import { ResizeEvent } from 'angular-resizable-element';
//import resizePolyfill from 'resize-polyfill';

const defaultPageSize = 50;

@Component({
    selector: 'app-display-ticket-chr',
    templateUrl: './display-ticket-chr.component.html',
    styleUrls: ['./display-ticket-chr.component.css']
})
export class DisplayTicketChrComponent implements OnInit, OnDestroy {

    FinalCatgory: number;
    height: number;
    solHeight: number;
    statusHeight: number;
    commentHeight: number;
    solutionHeight: number;
    descHeight: number;
    selectedRow: any;
    dataLoaded: boolean;
    ticketTypeLoaded = false;
    displayed = true;
    folderDisplayed = true;
    cat = [];
    step: string;
    assignGroupLength: number;
    columnDefinitions = [];
    gridOptions1: GridOption;
    gridOptions3: GridOption;
    gridOptions4: GridOption;
    gridOptions2: GridOption;
    dataset: any[];
    angularGrid1: AngularGridInstance;
    angularGrid2: AngularGridInstance;
    angularGrid3: AngularGridInstance;
    angularGrid4: AngularGridInstance;
    totalData: number;
    selectedTitles = [];
    selectedTitles2 = [];
    gridObj1: any;
    gridObj2: any;
    gridObj3: any;
    gridObj4: any;
    show: boolean;
    selected: number;
    ticketId: string;
    defaultStatus = false;
    defaultUser = false;
    defaultNextUser = false;
    name: string;
    desc: string;
    brief: string;
    rDate: string;
    dDate: string;
    comment: string;
    priority: string;
    ticketCreated = false;
    percent: number;
    @ViewChild('addCommentMessage') private addCommentMessage;
    @ViewChild('content') private content;
    ticketTypes: any;
    solution: string;
    types = [];
    rca: string;
    respObject: any;
    assignedUser: any;
    assignedGroup: any;
    currentUser: string;
    currentGroup: string;
    groups = [];
    supportGroupSelected: number;
    statusSelected: number;
    users = [];
    status = [];
    userSelected: number;
    assignee_copy: string;
    private groupDetails: any;
    private tId: any;
    lastCatId: number;
    lastParentId: number;
    totalItems: number;
    private statusIndex: any;
    statusName: string;
    private createbyid: any;
    private wfcresultId: any;
    respTime: string;
    comments = [];
    assignedToMe = false;
    closedticket = false;
    endIndicator = true;
    slaViolated = false;
    logs = [];
    private gid: number;
    private gid_copy: number;
    private aid: any;
    count: number;
    solutions = [];
    private modalReference: NgbModalRef;
    createdByMe = false;
    attachments = [];
    attachment = [];
    replyAttachment = [];
    uploadButtonName = 'Upload File';
    fileUploadUrl: string;
    formData: any;
    menus = [];
    ticketTab = true;
    commentsTab = true;
    solTab = true;
    attachTab = true;
    logTab = true;
    tabs: any;
    private slaTime: any;
    hasFollowupUser: boolean;
    followupUser: string;
    private SLA_INTERVAL_TIME = 60 * 1000;
    slaString: any;
    outerColor: any;
    innerColor: any;
    outerColorResp: any;
    innerColorResp: any;
    isSelfAssignedClicked: boolean;

    masterNameObj = [];
    page = 1;
    MAX_SIZE = 4;
    collectionSize: number;
    LIMIT = 7;
    start = 0;
    isDisabled = true;
    dynamicFields: any;
    private masterName: string;
    masterNameSelected: number;
    data = [];
    viewIncidentData = [];
    columnData = [];
    columnDefinitions1 = [];
    columnDefinitions3 = [];
    columnDefinitions4 = [];
    showGrid = false;
    columnData1 = [];
    columnData3 = [];
    columnData4 = [];
    columnDefinitions2 = [];
    showGrid1 = false;
    showGridForViewIncident = false;
    showGridForAddIncident = false;
    data2 = [];
    masterDataNameSelected: number;
    actions = [];
    statusSeq: number;
    escalatedTicket = false;
    isAsset: boolean;
    addIncidentData = [];
    selectedTitles4 = [];
    isApprovedTicket: boolean;
    isApproved: string;
    worker: any;
    searchTid: string;
    ticketCount: number;
    private addedTicket = [];
    isAddIncident: boolean;
    isViewIncident: boolean;
    canAddSolution: boolean;
    canAddComment: boolean;
    typeSeq: any;
    subRadioDisplay: boolean;
    subtypes = [];
    subTypeId: any;
    @ViewChild('statusChange') private statusChange;
    private TICKET_NOT_APPROVED_OR_REJECTED = '99';
    PROBLEM_SOLUTION_PROVIDED = 103;
    private INCIDENT_SOLUTION_PROVIDED = 2;
    private INCIDENT_TYPE_SEQ = 1;
    PROBLEM_TYPE_SEQ = 2;
    private FOLLOW_UP_SEQ = 15;
    private INCIDENT_CLOSE_SEQ = 0;
    private PROBLEM_CLOSE_SEQ = 104;
    private INCIDENT_ATTACHED_PROBLEM_CLOSE_SEQ = 23;
    private AWAITING_USER_CLARIFICATION = 12;
    private INERNAL_GUIDANCE_PROVIDED = 16;
    folderLoaded = false;
    solLoaded: boolean;
    comLoaded: boolean;
    resoTime: string;
    hideAttachment: boolean;
    replyHideAttachment: boolean;
    attachMsg: string;
    userGroups = [];
    @ViewChild('groupSelect') private groupSelect;
    private dialogRef: MatDialogRef<any, any>;
    userGroupSelected = 0;
    assetDisplayed: boolean;
    isRInfo: boolean;
    loginName: string;
    email: string;
    mobile: string;
    username: string;
    private baseCategories = [];
    respPercent: number;
    slaStringResp: string;
    slaViolatedResp = false;
    // groupName: string;
    wGroups = [];
    public activateUserReplay: boolean;

    usersReply: string;
    searchType: string;
    searchTypeStatus: string;
    searchText: string;
    private users_copy = [];
    private baseUser: boolean;
    psInfo = [];
    // public grpLevel: number;
    statusDisabled: boolean;
    isLowestLevel: boolean;
    lastComment: string;
    solProvided = false;
    diplaySLAMeter: boolean;
    lastSol: string;
    public isSelfAssigned: boolean;
    displayClaimNo: boolean;
    claimNo: string;
    lastCommentUser: string;
    public followUps = [];
    public followUpSelected: number;
    isFollowUp: boolean;
    private priorityId: number;
    escLevel: string;
    catFilterVal = 0;
    userFilterVal = 0;
    statusComment: string;
    private isCommentRequired: string;
    private commentSubscribe: Subscription;
    displayNewComment: boolean;
    private dialogRef1: MatDialogRef<any, any>;
    displayNewAttachment: boolean;
    private attachmentSubscribe: Subscription;
    private solSubscribe: Subscription;
    private modalSubscribe: Subscription;
    displayNewSolutions: boolean;
    ticketIdSearchLoaded: boolean;
    allStatus = [];
    filterSearchLoaded: boolean;
    categoryLoaded = false;
    inciCategories = [];
    searchCat = [];
    startDate: any;
    endDate: any;
    priorityType: number;
    private closeModalSubscribe: Subscription;
    isChangeStatus: boolean;
    private aGrpLvl: number;
    isUserReplied: boolean;
    @Input() typeChecked: any;
    @Input() clientId: any;
    @Input() userGroupId: any;
    @Input() grpLevel: any;
    @Input() groupName: any;
    @Input() notifier: any;
    @Input() folderClicked: any;
    @Input() seq: any;
    @Input() inciId: any;
    @Input() isSearch: boolean;
    @Input() isViewTicket: boolean;
    @Input() isCreateTicket: boolean;
    @Output() tabledata = new EventEmitter();
    @Output() search = new EventEmitter();
    @Output() loadView = new EventEmitter();
    private oldStatusId: number;
    searchStatusSelected: number;
    isBlankRequester = false;
    isBlankDesc = false;
    isBlankLong = false;
    isBlankClaim = false;
    fromDate: string;
    toDate: string;
    minDate: any;
    maxDate: any;
    formdata: any;
    nextOffset = 0;
    searchPageSize: number;
    top: number;
    skip: number;
    query: any;
    // service: any;
    totalSearchItems: number;
    private commentDialogRef: MatDialogRef<any, any>;
    resolution_status: string;
    reponse_status: string;
    respClockStatus: string;
    resoClockStatus: string;
    reponseStatus: boolean;
    resolutionStatus: boolean;
    private disabledCount: number;
    canForward: boolean;
    private userAssign: boolean;
    MAX_FILE_UPLOAD = 10;
    INCI_RE_OPEN_STATUS = 26;
    INCI_ESCALATED_STATUS = 7;
    uploadMsg: string;
    private addInciPermission: boolean;
    private addSolPermission: boolean;
    addSelfPermission: boolean;
    private addClosedPermission: boolean;
    selectedIndextab: number;
    private attachFile: number;

    constructor(private messageService: MessageService, private _rest: RestApiService, private route: Router,
        private modalService: NgbModal, private socketService: SocketService,
        private dialog: MatDialog, private actRoute: ActivatedRoute) {
        this.commentSubscribe = this.socketService.commentSubject.subscribe((data) => {
            if (this.userGroupId === data.groupId) {
                if (data.userId !== Number(this.messageService.getUserId())) {
                    // console.log('-->: ' + JSON.stringify(data));
                    if (this.tId === data.ticketId) {
                        this.displayNewComment = true;
                        this.lastComment = data.feedback;
                        this.lastCommentUser = data.name;
                        delete data.ticketId;
                        delete data.groupId;
                        this.comments.unshift(data);
                    }
                }
            }
        });
        this.attachmentSubscribe = this.socketService.attachmentSubject.subscribe((data) => {
            if (this.userGroupId === data.groupId) {
                // // console.log('-->: ' + JSON.stringify(data));
                if (data.userId !== Number(this.messageService.getUserId())) {
                    if (this.tId === data.ticketId) {
                        this.displayNewAttachment = true;
                        delete data.ticketId;
                        delete data.groupId;
                    }
                }
            }
        });
        this.solSubscribe = this.socketService.solPrvdSubject.subscribe((data) => {
            if (this.userGroupId === data.groupId) {
                // // console.log('-->: ' + JSON.stringify(data));
                if (data.userId !== Number(this.messageService.getUserId())) {
                    if (this.tId === data.ticketId) {
                        this.displayNewSolutions = true;
                        this.lastSol = data.solutions;
                        delete data.ticketId;
                        delete data.groupId;
                        this.solutions.unshift(data);
                    }
                }
            }
        });
    }

    angularGridReady1(angularGrid: AngularGridInstance) {
        this.angularGrid1 = angularGrid;
        this.gridObj1 = angularGrid && angularGrid.slickGrid || {};
        this.columnData = this.gridObj1.getColumns();
    }

    angularGridReady2(angularGrid: AngularGridInstance) {
        this.angularGrid2 = angularGrid;
        this.gridObj2 = angularGrid && angularGrid.slickGrid || {};
        this.columnData1 = this.gridObj2.getColumns();
    }

    angularGridReady3(angularGrid: AngularGridInstance) {
        this.angularGrid3 = angularGrid;
        this.gridObj3 = angularGrid && angularGrid.slickGrid || {};
        this.columnData3 = this.gridObj3.getColumns();
    }

    angularGridReady4(angularGrid: AngularGridInstance) {
        this.angularGrid4 = angularGrid;
        this.gridObj4 = angularGrid && angularGrid.slickGrid || {};
        this.columnData4 = this.gridObj4.getColumns();
    }

    ngOnInit() {
        this.attachFile = 0;
        this.terminateWorker();
        this.totalSearchItems = 0;
        this.searchPageSize = 0;
        if (/Edge/.test(navigator.userAgent)) {
            this.height = 120;
            this.commentHeight = 50;
            this.solutionHeight = 50;
            this.descHeight = 50;
            this.solHeight = 120;
            this.statusHeight = 50;
        }
        this.toDate = '';
        this.fromDate = '';
        const now = new Date();
        const nowDate = new Date();
        const nowMonth = nowDate.getMonth();
        const nowDay = nowDate.getDate();
        const nowYear = nowDate.getFullYear();
        this.maxDate = new Date(nowYear, nowMonth, nowDay);
        // this.toDate = this.formatDate(this.maxDate);
        this.endDate = this.messageService.ticketConverter(this.maxDate, 1);
        const previousDate = new Date(now.setDate(now.getDate() - 1));
        const previousMonth = previousDate.getMonth();
        const previousDay = previousDate.getDate();
        const previousYear = previousDate.getFullYear();
        this.minDate = new Date(previousYear, previousMonth, previousDay);
        // this.fromDate = this.formatDate(this.minDate);
        this.startDate = this.messageService.ticketConverter(this.minDate, 1);
        this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
        this.userGroupSelected = this.userGroupId;
        this.isSelfAssignedClicked = false;
        this.gridOptions1 = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            // enableCheckboxSelector: true,
            enableRowSelection: true,

        };
        this.gridOptions2 = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            enableCheckboxSelector: true,
            enableRowSelection: true,

        };
        this.gridOptions3 = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            // enableCheckboxSelector: true,
            enableRowSelection: true,

        };
        this.gridOptions4 = {
            enableAutoResize: true,       // true by default
            enableCellNavigation: true,
            enableFiltering: true,
            editable: true,
            rowSelectionOptions: {
                selectActiveRow: false
            },
            enableCheckboxSelector: true,
            enableRowSelection: true,
        };

        this.closeModalSubscribe = this.messageService.closeModalSubject.subscribe((type) => {
            this.modalReference.close();
            if (this.isViewTicket) {
                this.folderClick(this.folderClicked);
            }
        });
        this.modalSubscribe = this.messageService.getModalData().subscribe(olddata => {
            this.formdata = { clientId: this.clientId };
            this.ticketId = olddata.ticket_id;
            this.name = olddata.reqInfo;
            this.brief = olddata.longDesc;
            this.usersReply = '';
            this.desc = olddata.tName;
            this.tId = olddata.id;
            this.createbyid = Number(olddata.createbyid);
            // this.rDate = olddata.requestedDate;
            console.log('requestedDate13:', olddata.requestedDate);
            console.log('requestedDate type13:', typeof olddata.requestedDate);
            // this.rDate = this.messageService.datePipeFunc(olddata.requestedDate);
                        const requestedDateNew = olddata.requestedDate;

            if (requestedDateNew) {
                const parts = requestedDateNew.split(' ');
                const dateParts = parts[0].split('-');
                const timeParts = parts[1].split(':');

                const utcDate = new Date(Date.UTC(
                    Number(dateParts[2]),
                    Number(dateParts[1]) - 1,
                    Number(dateParts[0]),
                    Number(timeParts[0]),
                    Number(timeParts[1])
                ));

                this.rDate = this.messageService.datePipeFunc(utcDate);
            }

            this.onPageLoad('start');
        });     // get modal data end
    }

    onPageLoad(type) {
        this.selectedIndextab = -1;
        this.addInciPermission = false;
        this.addSolPermission = false;
        this.addSelfPermission = false;
        this.isBlankLong = false;
        this.isBlankDesc = false;
        this.isBlankRequester = false;
        this.isBlankClaim = false;
        this.dataLoaded = true;
        this.isFollowUp = false;
        this.ticketCreated = false;
        this.solLoaded = true;
        this.comLoaded = true;
        this.showGrid = false;
        this.showGrid1 = false;
        this.showGridForViewIncident = false;
        this.showGridForAddIncident = false;
        this.activateUserReplay = false;
        this.isRInfo = false;
        this.hasFollowupUser = false;
        this.isChangeStatus = false;
        this.isUserReplied = false;
        this.defaultStatus = false;
        this.defaultUser = false;
        this.defaultNextUser = false;
        this.cat = [];
        this.createdByMe = false;
        this.hideAttachment = true;
        this.replyHideAttachment = true;
        this.statusDisabled = false;
        this.diplaySLAMeter = false;
        this.isSelfAssigned = false;
        this.solProvided = false;
        this.ticketTab = true;
        this.commentsTab = true;
        this.solTab = true;
        this.attachTab = true;
        this.logTab = true;
        this.isAsset = false;
        this.psInfo = [];
        this.isAddIncident = false;
        this.isViewIncident = false;
        this.displayClaimNo = false;
        this.canAddSolution = false;
        this.canForward = false;
        this.userAssign = false;
        this.users = [];
        this.users_copy = [];
        this.statusName = '';
        this.currentUser = '';
        this.currentGroup = '';
        this.count = 0;
        this.attachment = [];
        this.replyAttachment = [];

        this.baseCategories = [];
        this.ticketTypes = [];
        this.status = [];
        this.tabs = [];
        this.actions = [];
        this.dynamicFields = [];
        this.addClosedPermission = false;
        if (type === 'start') {
            this.modalReference = this.modalService.open(this.content, { size: 'lg', windowClass: 'modalheight' });
            if (this.modalReference !== undefined) {
                setTimeout(() => {
                    this.ieTextareaResize();
                }, 1000);
            }
            this.modalReference.result.then((result) => {
                if (this.isViewTicket) {
                    this.folderClick(this.folderClicked);
                }
                if (this.isSearch) {
                    this.ticketSearch();
                }
                this.terminateWorker();
            }, (reason) => {
                if (this.isViewTicket) {
                    this.folderClick(this.folderClicked);
                }
                if (this.isSearch) {
                    this.ticketSearch();
                }
                this.terminateWorker();
            });
        }

        Promise.all([this.getTab(), this.getTicketDetails()]).then((values) => {
            if (this.addInciPermission) {
                if (this.statusSeq === this.PROBLEM_SOLUTION_PROVIDED || this.closedticket) {
                    this.isAddIncident = false;
                } else {
                    this.isAddIncident = true;
                }
            }
            if (this.addSolPermission) {
                if (!this.closedticket) {
                    if (this.aid === Number(this.messageService.getUserId())) {
                        this.canAddSolution = true;
                    }
                }
            }
            if (this.addSelfPermission) {
                if (!this.closedticket) {
                    if (this.assignedToMe && (this.aid !== Number(this.messageService.getUserId()))) {

                        this.isSelfAssigned = true;
                    }
                }
            }
            if (this.addClosedPermission) {
                if (this.closedticket) {
                    this.ticketCreated = false;
                } else {
                    this.ticketCreated = true;
                }
            }
        });
    }

    getTab() {
        return new Promise((resolve, reject) => {
            const promise = this._rest.httpClient.get(this._rest.apiRoot + '/getDynamicTabActionTicketTypeWise?clientId='
                + this.clientId + '&ticketTypeId=' + this.typeChecked + '&user_id=' + this.messageService.getUserId() +
                '&supportgrp_id=' + this.userGroupId).toPromise();
            promise.then((data) => {
                if (data.success) {
                    this.tabs = data.details.tabs;
                    this.actions = data.details.actions;
                    for (let i = 0; i < this.tabs.length; i++) {
                        if (this.tabs[i].fid === 10) {
                            this.ticketTab = false;
                            // console.log('ticket tab===', this.ticketTab);
                        } else if (this.tabs[i].fid === 11) {
                            this.commentsTab = false;
                        } else if (this.tabs[i].fid === 12) {
                            this.solTab = false;
                            this.getSolutions();
                        } else if (this.tabs[i].fid === 13) {
                            this.attachTab = false;
                        } else if (this.tabs[i].fid === 14) {
                            this.logTab = false;
                        } else if (this.tabs[i].fid === 15) {
                            if (this.assetDisplayed) {
                                this.isAsset = true;
                            }
                        } else if (this.tabs[i].fid === 16) {
                            if (this.assetDisplayed) {
                                this.isAsset = true;
                            }
                        } else if (this.tabs[i].fid === 17) {
                            if (this.seq === this.PROBLEM_TYPE_SEQ) {
                                this.isViewIncident = true;
                            }
                        } else if (this.tabs[i].fid === 18) {
                            if (this.seq === this.PROBLEM_TYPE_SEQ) {
                                this.addInciPermission = true;
                            }
                        } else if (this.tabs[i].fid === 19) {
                            this.isRInfo = true;
                        } else if (this.tabs[i].fid === 23) {
                            this.diplaySLAMeter = true;
                        }
                    }
                    for (let i = 0; i < this.actions.length; i++) {

                        if (this.actions[i].fid === 9) {
                            // // console.log('this.ticketCreated : ');
                            this.addClosedPermission = true;
                        }
                        if (this.actions[i].fid === 24) {
                            this.addSolPermission = true;
                        }
                        if (this.actions[i].fid === 34) {
                            this.addSelfPermission = true;
                        }
                    }
                    resolve('getDynamicTabActionTicketTypeWise');
                } else {
                    alert(data.errorMessage);
                }
            }).catch((error) => {
                // console.log('Promise rejected with ' + JSON.stringify(error));
            });
        });
    }

    getTicketDetails() {
        return new Promise((resolve, reject) => {
            const promise = this._rest.httpClient.get(this._rest.apiRoot + '/getTicketDetailsById?clientId=' + this.clientId +
                '&ticketId=' + this.tId).toPromise();
            promise.then((data) => {
                if (data.success) {
                    const newdata = data.details[0];
                    this.statusSeq = newdata.seq;
                    this.priority = newdata.priority;
                    this.gid = newdata.gid;
                    this.escLevel = newdata.escalated_to_grp_nm;
                    this.priorityId = newdata.busi_priority_id;
                    this.gid_copy = newdata.gid;
                    this.aid = newdata.aid;
                    this.claimNo = newdata.claimNo;
                    this.aGrpLvl = newdata.group_level;
                    this.isApproved = newdata.is_approved_problem_ticket;
                    this.statusName = newdata.status;
                    this.dDate = this.messageService.datePipeFunc(newdata.dDate);
                    if (this.statusSeq === this.AWAITING_USER_CLARIFICATION && this.grpLevel === 0) {
                        this.selectedIndextab = 6;
                    }
                    this.wfcresultId = newdata.ids;
                    this.currentUser = newdata.assignee || 'Not Assigned';
                    this.assignee_copy = newdata.assignee || 'Not Assigned';
                    this.currentGroup = newdata.LEVELSHORTDESC;

                    this.isSelfAssignedClicked = false;
                    if (this.claimNo && this.claimNo !== null && this.claimNo !== '') {
                        this.displayClaimNo = true;
                    } else {
                        this.claimNo = '';
                    }
                    this.isLowestLevel = false;
                    this.closedticket = false;

                    if (this.statusSeq === this.INCIDENT_CLOSE_SEQ || this.statusSeq === this.PROBLEM_CLOSE_SEQ ||
                        this.statusSeq === this.INCIDENT_ATTACHED_PROBLEM_CLOSE_SEQ) {
                        this.closedticket = true;
                    }
                    resolve('getTicketDetailsById');
                    this.oldStatusId = newdata.statusId;
                    this.displayNewComment = false;
                    this.displayNewAttachment = false;
                    this.displayNewSolutions = false;

                    if (this.grpLevel === 0) {
                        this.isLowestLevel = true;
                    }

                    if (this.statusSeq === this.AWAITING_USER_CLARIFICATION) {
                        this.statusDisabled = true;
                        if (this.isLowestLevel) {
                            this.activateUserReplay = true;
                        }
                    }


                    // this.getLastComment();
                    this.getComments();
                    if (newdata.END_INDICATOR === '0') {
                        this.endIndicator = false;
                    }

                    if (!this.closedticket) {
                        if (this.statusSeq === this.INCIDENT_SOLUTION_PROVIDED || this.statusSeq === this.PROBLEM_SOLUTION_PROVIDED) {
                            this.solProvided = true;
                        }
                        this.canAddComment = true;
                        // // // console.log('this.aid:' + this.aid);

                        // // // console.log('user assigned');
                        if (this.createbyid === Number(this.messageService.getUserId())) {
                            this.createdByMe = true;
                            if (this.grpLevel === 0) {
                                this.statusDisabled = true;
                            }
                        }
                        if (this.aid === Number(this.messageService.getUserId())) {
                            if (this.userGroupId === this.gid) {
                                this.userAssign = true;
                                if (this.statusSeq !== this.AWAITING_USER_CLARIFICATION) {
                                    this.canForward = true;
                                }
                                this.assignedToMe = true;
                            }
                            this.isApprovedTicket = false;
                            if (this.seq === this.PROBLEM_TYPE_SEQ) {
                                if (this.isApproved === this.TICKET_NOT_APPROVED_OR_REJECTED) {
                                    this.assignedToMe = false;
                                    this.isApprovedTicket = true;
                                }
                            }
                            // if (this.statusSeq === this.AWAITING_USER_CLARIFICATION) {
                            //     this.statusDisabled = true;
                            // }
                        } else {
                            this.isApprovedTicket = false;
                            this.statusDisabled = true;
                            if (this.userGroupId === this.gid) {
                                if (this.statusSeq !== this.AWAITING_USER_CLARIFICATION && this.grpLevel === 2) {
                                    this.canForward = true;
                                }
                                this.assignedToMe = true;
                            } else {
                                this.assignedToMe = false;
                            }
                        }
                    } else {
                        this.assignedToMe = false;
                        this.canAddComment = false;
                    }
                    // // console.log('this.assignedToMe:2' + this.assignedToMe);
                    if (this.seq === this.PROBLEM_TYPE_SEQ) {
                        this.isAsset = false;
                    } else {
                        if (this.assetDisplayed) {
                            this.isAsset = true;
                        }

                    }
                    // // console.log('end indicator:' + this.endIndicator);
                    if (this.createbyid === Number(this.messageService.getUserId())) {
                        // // console.log(typeof this.statusSeq);
                        if (this.statusSeq === this.INCIDENT_SOLUTION_PROVIDED && this.userGroupId === this.gid) {
                            this.escalatedTicket = true;
                            this.uploadMsg = 'Please click Escalate or Re-Open button to save it.';
                        } else {
                            this.escalatedTicket = false;
                            this.uploadMsg = 'Please click Update button to save it.';
                        }
                        // if (this.closedticket) {
                        //   this.ticketCreated = false;
                        // } else {
                        //   this.ticketCreated = true;
                        // }
                        // // // console.log('this.ticketCreated:' + this.ticketCreated);
                    } else {
                        this.uploadMsg = 'Please click Update button to save it.';
                    }
                    this.groupDetails = undefined;
                    this.baseUser = false;

                    this._rest.checkOfflineNotificationData(this.tId, this.userGroupId,
                        this.messageService.getUserId(), this.clientId).subscribe((res2) => {
                            this.respObject = res2;
                            if (this.respObject.success) {
                                const data1 = this.respObject.details;
                                if (data1.comment) {
                                    this.displayNewComment = true;
                                }
                                if (data1.solution) {
                                    this.displayNewSolutions = true;
                                }
                                if (data1.attach) {
                                    this.displayNewAttachment = true;
                                }
                            }
                        });

                    this._rest.getActiveCategoryDetails(this.tId).subscribe((res2) => {
                        this.respObject = res2;
                        if (this.respObject.success) {
                            this.lastCatId = this.respObject.details[0].last_cat_id;
                            this.lastParentId = this.respObject.details[0].last_cat_parent_id;
                            // this._rest.getTicketCategoryDetailsWithGroup(this.clientId, this.tId, this.typeChecked,
                            //     8, this.userGroupId).subscribe((res1) => {
                            this._rest.getTicketCategoryDetails_lntchr(this.clientId, this.tId, this.typeChecked, 8, this.createbyid, this.gid,
                                this.lastCatId).subscribe((res1) => {
                                    this.respObject = res1;
                                    this.FinalCatgory = 0;
                                    this.categoryLoaded = true;
                                    if (this.respObject.success) {
                                        // // // console.log(JSON.stringify(this.respObject.details.cat));
                                        this.baseCategories = this.messageService.copyArray(this.respObject.details.cat);
                                        this.ticketTypes = this.respObject.details.cat;
                                        // console.log('ticket type====', this.ticketTypes);
                                        this.FinalCatgory = this.ticketTypes[this.ticketTypes.length - 1].options[0].id;
                                        // console.log('............... ' + this.FinalCatgory);
                                        this.respObject.details.status.unshift({ id: 0, name: 'Select Status' });
                                        this.status = this.respObject.details.status;
                                        // this.disabledCount = this.respObject.details.disabled;
                                        this.disabledCount = 8;
                                        this.statusSelected = 0;
                                        const followup = this.respObject.details.followUpName;
                                        if (followup.length > 0) {
                                            this.hasFollowupUser = true;
                                            this.followupUser = followup[0].followup_users_name;
                                        }
                                        this.respTime = this.messageService.minToDHM(this.respObject.details.expectedTime[0].RESPONSETIME);
                                        this.resoTime = this.messageService.minToDHM(this.respObject.details.expectedTime[0].RESOLUTIONTIME);
                                        for (let i = 0; i < this.respObject.details.fields.length; i++) {
                                            if (this.respObject.details.fields[i].predifinedValue !== null) {
                                                // // // console.log(JSON.stringify(this.respObject.details.fields[i]))
                                                this.respObject.details.fields[i].values = this.respObject.details.fields[i].predifinedValue.split(',');
                                            }
                                        }
                                        this.dynamicFields = this.respObject.details.fields;
                                        this.getNextAssignDetails();
                                    } else {
                                        this.baseCategories = [];
                                        this.ticketTypes = [];
                                        this.status = [];
                                        alert(this.respObject.errorMessage);
                                    }
                                }, (err) => {
                                    // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                                });

                        } else {
                            alert(this.respObject.errorMessage);
                        }
                    }, (err) => {

                    });
                    this.percent = 0;
                    this.respPercent = 0;

                    // this.slaTime = setInterval(() => {
                    //   this.getSLAPercentage();
                    // }, this.SLA_INTERVAL_TIME);

                } else {
                    alert(data.errorMessage);
                }

            }).catch((error) => {
                // console.log('Promise rejected with ' + JSON.stringify(error));
            });
        });
    }

    onDescResizeEnd(event: ResizeEvent) {
        if (/Edge/.test(navigator.userAgent)) {
            if (event) {
                if (event.rectangle.height != null) {
                    this.descHeight = event.rectangle.height;
                }
            }
        }
    }

    getNextAssignDetails() {
        this._rest.getNextAssigneeDtls(this.clientId, this.tId, this.messageService.getUserId()).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                // // console.log('--->' + JSON.stringify(this.respObject));
                // this.types = this.respObject.details;
                this.assignGroupLength = this.respObject.details.length;
                if (this.respObject.details.length > 0) {
                    this.groupDetails = this.respObject.details[0];
                    this.supportGroupSelected = this.groupDetails.groupId;
                    this.userSelected = this.groupDetails.userId;
                    // // console.log('selected :: ' + this.supportGroupSelected, this.userSelected);
                } else {
                    this.supportGroupSelected = 0;
                    this.userSelected = this.aid;
                }
                // // console.log(this.groupDetails);
                this.baseUser = true;
                // console.log('before aGrpLvl : ' + this.aGrpLvl);
                if (this.aGrpLvl > 0) {
                    // console.log('inside aGrpLvl : ' + this.aGrpLvl);
                    this.getUser(this.gid);
                    this.getGroup();
                }
                // // // console.log(this.supportGroupSelected, this.userSelected);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
        });
    }

    onSolutionResizeEnd(event: ResizeEvent) {
        if (/Edge/.test(navigator.userAgent)) {
            if (event) {
                if (event.rectangle.height != null) {
                    this.solutionHeight = event.rectangle.height;
                }
            }
        }
    }

    onCommentResizeEnd(event: ResizeEvent) {
        if (/Edge/.test(navigator.userAgent)) {
            if (event) {
                if (event.rectangle.height != null) {
                    this.commentHeight = event.rectangle.height;
                }
            }
        }
    }

    onResizeCommentEnd(event: ResizeEvent) {
        if (/Edge/.test(navigator.userAgent)) {
            if (event) {
                // console.log(event);
                if (event.rectangle.height != null) {
                    this.height = event.rectangle.height;
                }
            }
        }
    }

    onResizeSolEnd(event: ResizeEvent) {
        if (/Edge/.test(navigator.userAgent)) {
            if (event) {
                // console.log(event);
                if (event.rectangle.height != null) {
                    this.solHeight = event.rectangle.height;
                }
            }
        }
    }

    onStatusResizeEnd(event: ResizeEvent) {
        if (/Edge/.test(navigator.userAgent)) {
            if (event) {
                // console.log(event);
                if (event.rectangle.height != null) {
                    this.statusHeight = event.rectangle.height;
                }
            }
        }
    }

    getComments() {
        this._rest.getCommentsByTicketId(this.tId).subscribe((res1) => {
            this.respObject = res1;
            this.lastComment = '';
            this.lastCommentUser = '';
            this.comments = [];
            // // // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
                this.comments = this.respObject.details;
                if (this.comments.length > 0) {
                    this.lastComment = this.respObject.details[0].feedback;
                    this.lastCommentUser = this.respObject.details[0].name;
                }
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }

    terminateWorker() {
        if (this.worker) {
            this.worker.terminate();
        }
    }

    getSolutions() {
        this._rest.getSolutionsTicketWise(this.tId).subscribe((res1) => {
            this.respObject = res1;
            this.solutions = [];
            if (this.respObject.success) {
                this.solutions = this.respObject.details;
                if (this.solutions.length > 0) {
                    this.lastSol = this.solutions[0].solutions;
                } else {
                    this.lastSol = this.messageService.NO_SOLUTION;
                }
            } else {
                // this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    onFileComplete(data: any) {
        if (data.success) {
            this.hideAttachment = false;
            this.attachFile = 0;
            if (this.attachment.length > this.MAX_FILE_UPLOAD - 1) {
                this.attachMsg = 'More than ' + this.MAX_FILE_UPLOAD + ' files is not permitted';
            } else {
                this.attachment.push({ originalName: data.fileName, fileName: data.changedName });
                if (this.attachment.length > 1) {
                    this.attachMsg = this.attachment.length + ' files uploaded successfully. ' + this.uploadMsg;
                } else {
                    this.attachMsg = this.attachment.length + ' file uploaded successfully. ' + this.uploadMsg;
                }
            }
        }
    }

    onFileCompleteReply(data: any) {
        if (data.success) {
            this.replyHideAttachment = false;
            if (this.replyAttachment.length > this.MAX_FILE_UPLOAD - 1) {
                this.attachMsg = 'More than ' + this.MAX_FILE_UPLOAD + ' files is not permitted';
            } else {
                this.replyAttachment.push({ originalName: data.fileName, fileName: data.changedName });
                if (this.attachment.length > 1) {
                    this.attachMsg = this.replyAttachment.length + ' files uploaded successfully';
                } else {
                    this.attachMsg = this.replyAttachment.length + ' file uploaded successfully';
                }
            }
        }
    }

    closeTicket() {
        this.modalReference.close();
        if (this.ticketCreated) {
            const modalRef = this.modalService.open(CSATmodalCHRComponent, {
                size: 'lg', windowClass: 'large-modal'
            });
            modalRef.componentInstance.id = this.wfcresultId;
            modalRef.componentInstance.user_id = this.messageService.getUserId();
            modalRef.componentInstance.ticketId = this.tId;
            modalRef.componentInstance.seq = this.seq;
            modalRef.componentInstance.type = 'csat';
            modalRef.componentInstance.header = 'CSAT-Satisfaction Feedback';
            modalRef.componentInstance.groupId = this.userGroupId;
            modalRef.componentInstance.client_id = this.clientId;
        }
    }

    onCellClicked1(e, args) {
        const metadata = this.angularGrid1.gridService.getColumnFromEventArguments(args);
        // // // console.log(metadata);

        if (metadata.columnDef.id === 'delete') {
            // // console.log(JSON.stringify(metadata.dataContext));
            if (confirm('Are you sure?')) {
                this._rest.deleteTicketAssetData({
                    id: metadata.dataContext.id,
                    ticketId: this.tId,
                    WFCCResult_id: this.wfcresultId,
                    user_id: this.messageService.getUserId()
                }).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.angularGrid1.gridService.deleteDataGridItemById(metadata.dataContext.id);
                    } else {
                        alert(this.messageService.SERVER_ERROR);
                    }
                }, (err) => {
                    // alert(this.messageService.SERVER_ERROR);
                });
            }
        }
    }

    onMasterDataChange(selectedIndex: any) {
        this._rest.getAssetManagementData(this.clientId, this.masterDataNameSelected).subscribe((res) => {
            this.respObject = res;
            // // // console.log(this.respObject)
            if (this.respObject.success) {
                this.gridObj2.getSelectionModel().setSelectedRanges([]);
                this.data2 = [];
                const data1 = [];
                for (let i = 0; i < this.columnData1.length; i++) {
                    data1.push(this.columnData1[i]);
                }
                const data = this.respObject.details;
                const columnNameObj = data.columnObj;
                const columnValueObj = data.valueObj;
                data1.push({ id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true });
                for (let i = 0; i < columnNameObj.length; i++) {
                    data1.push({
                        id: columnNameObj[i].columnName,
                        name: columnNameObj[i].columnName,
                        field: columnNameObj[i].id,
                        sortable: true,
                        filterable: true
                    });

                }
                this.gridObj2.setColumns(data1);
                const colval = [];
                for (let j = 0; j < columnValueObj.length; j++) {
                    const columVal = columnValueObj[j].columVal;
                    const descId = columnValueObj[j].id;
                    const columnValue = columVal.split(',');
                    // // // console.log('column=', JSON.stringify(columnValue));
                    const jsonval = {};
                    jsonval['id'] = descId;
                    for (let k = 0; k < columnValue.length; k++) {
                        const attrVal = columnValue[k];
                        const attrValue = attrVal.split(':');

                        jsonval[attrValue[0]] = attrValue[1];
                    }
                    colval.push(jsonval);
                }
                this.data2 = colval;


            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    escalateTicket() {
        const data = {
            id: this.tId,
            WFCClientResultId: this.wfcresultId,
            createdBy: this.messageService.getUserId(),
            clientId: this.clientId,
            attachedFilePath: this.attachment,
            ticketTypeId: this.typeChecked,
            ticketStatusSeq: this.INCI_ESCALATED_STATUS
        };
        this.dataLoaded = false;
        this._rest.escalationByCreatorAfterResolve(data).subscribe((res1) => {
            this.respObject = res1;
            // // // console.log(JSON.stringify(this.respObject));
            this.dataLoaded = true;
            if (this.respObject.success) {
                if (this.isViewTicket) {
                    this.folderClick(this.folderClicked);
                }
                alert('Escalated successfully');
                // if (this.slaTime) {
                //   clearInterval(this.slaTime);
                // }
                this.terminateWorker();
                this.modalReference.close();
                // this.getSolutions();
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }

    reopenTicket() {
        const data = {
            id: this.tId,
            WFCClientResultId: this.wfcresultId,
            createdBy: this.messageService.getUserId(),
            clientId: this.clientId,
            attachedFilePath: this.attachment,
            ticketTypeId: this.typeChecked,
            ticketStatusSeq: this.INCI_RE_OPEN_STATUS
        };
        this.dataLoaded = false;
        this._rest.escalationByCreatorAfterResolve(data).subscribe((res1) => {
            this.respObject = res1;
            // // // console.log(JSON.stringify(this.respObject));
            this.dataLoaded = true;
            if (this.respObject.success) {
                if (this.isViewTicket) {
                    this.folderClick(this.folderClicked);
                }
                alert('Re-Open successfully');
                // if (this.slaTime) {
                //   clearInterval(this.slaTime);
                // }
                this.terminateWorker();
                this.modalReference.close();
                // this.getSolutions();
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }

    approveTicket() {
        if (this.groupDetails) {
            const modalRef = this.modalService.open(CSATmodalCHRComponent, {
                size: 'lg', windowClass: 'large-modal'
            });
            modalRef.componentInstance.typeChecked = this.typeChecked;
            modalRef.componentInstance.id = this.wfcresultId;
            modalRef.componentInstance.user_id = this.messageService.getUserId();
            modalRef.componentInstance.ticketId = this.tId;
            modalRef.componentInstance.cat_id = this.lastCatId;
            modalRef.componentInstance.parent_cat_id = this.lastParentId;
            modalRef.componentInstance.groupId = this.groupDetails.groupId;
            modalRef.componentInstance.selectedUserID = this.groupDetails.userId;
            modalRef.componentInstance.ticket_type_seq = this.seq;
            modalRef.componentInstance.type = 'approve';
            modalRef.componentInstance.header = 'Approval Form';
        } else {
            alert('You don\'t have any next group to be forwarded');
        }
    }

    handleSelectedRowsChanged4(eventData: any, args: any) {
        if (Array.isArray(args.rows)) {
            this.selectedTitles4 = args.rows.map(idx => {
                const item = this.gridObj4.getDataItem(idx);
                return item || '';
            });
        }
    }

    saveIncidentData() {
        let incIds = '';
        for (let i = 0; i < this.addedTicket.length; i++) {
            if (i === this.addedTicket.length - 1) {
                incIds += this.addedTicket[i].id;
            } else {
                incIds += this.addedTicket[i].id + ',';
            }
        }
        const data = {
            ticketId: this.tId,
            incident_ticket_list: incIds,
            createdBy: this.messageService.getUserId(),
            client_id: this.clientId
        };
        this._rest.addNewIncidentInProblem(data).subscribe((res1) => {
            this.respObject = res1;
            // // // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
                alert('Request Added successfully');
                // this.getSolutions();
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }

    onCellClicked3(eventData: any, args: any) {
        const metadata = this.angularGrid3.gridService.getColumnFromEventArguments(args);
        // // // console.log(metadata);

        if (metadata.columnDef.id === 'delete') {
            // // console.log(JSON.stringify(metadata.dataContext));
            if (confirm('Are you sure?')) {
                // const incIds = [];
                // incIds.push(metadata.dataContext.id+"");
                this._rest.deleteNewIncidentInProblem({
                    incident_ticket_list: metadata.dataContext.id + '',
                    id: this.tId,
                    user_id: this.messageService.getUserId()
                }).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.angularGrid3.gridService.deleteDataGridItemById(metadata.dataContext.id);
                    } else {
                        alert(this.respObject.errorMessage);
                    }
                }, (err) => {
                    // alert(this.messageService.SERVER_ERROR);
                });
            }
        }
    }

    searchTicket() {
        if (this.searchTid && this.searchTid !== '') {
            const data = {
                ticketId: this.searchTid, clientId: this.clientId
            };
            this.ticketIdSearchLoaded = false;
            this._rest.getTicketById(data).subscribe((res1) => {
                this.respObject = res1;
                this.ticketIdSearchLoaded = true;
                // // // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                    this.gridObj4.getSelectionModel().setSelectedRanges([]);
                    this.searchTid = '';
                    for (let i = 0; i < this.respObject.details.length; i++) {
                        this.respObject.details[i].createdSince =
                            this.messageService.datePipeFunc(this.respObject.details[i].createdSince);
                        this.respObject.details[i].dDate =
                            this.messageService.datePipeFunc(this.respObject.details[i].dDate);
                        this.respObject.details[i].updateDate =
                            this.messageService.datePipeFunc(this.respObject.details[i].updateDate);
                        if (this.respObject.details[i].closureDate === undefined) {
                            this.respObject.details[i].closureDate = '';
                        } else {
                            this.respObject.details[i].closureDate =
                                this.messageService.datePipeFunc(this.respObject.details[i].closureDate);
                        }
                        this.respObject.details[i].requestedDate =
                            this.messageService.datePipeFunc(this.respObject.details[i].requestedDate);
                    }
                    this.addIncidentData = this.respObject.details;
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else {
            alert(this.messageService.BLANK_TICKETID);
        }
    }


    // searchTicketWithFilter(query, isNewSearch) {
    //     console.log('pagesize===', this.searchPageSize);
    //     if (isNewSearch === 1) {
    //         this.service.resetPaginationOptions();
    //         this.gridOptions4.pagination.totalItems = 0;
    //         this.nextOffset = 1;
    //         if (this.searchPageSize === 0) {
    //             query = '$top=' + defaultPageSize;
    //         } else {
    //             query = '$top=' + this.searchPageSize;
    //         }
    //     }
    //     // return new Promise((resolve, reject) => {
    //     const queryParams = query.toLowerCase().split('&');
    //     for (const param of queryParams) {
    //         console.log('param====' + JSON.stringify(param) + '==============' + param.includes('$skip='));
    //         if (param.includes('$top=')) {
    //             this.top = +(param.substring('$top='.length));
    //         }
    //         if (param.includes('$skip=')) {
    //             this.skip = +(param.substring('$skip='.length));
    //         } else {
    //             this.skip = 0;
    //         }
    //     }
    //     console.log('pagesize11111===', this.searchPageSize);
    //     if (this.searchPageSize === 0) {
    //         this.searchPageSize = defaultPageSize;
    //     } else {
    //         this.searchPageSize = this.top;
    //     }
    //     console.log('pagesize22222222222222222===', this.searchPageSize);
    //     this.nextOffset = this.skip;
    //     console.log('AAAAAAAAAAAAAAAAA===', this.nextOffset);
    //     // =====================================================
    //     const tdate = this.messageService.ticketConverter(this.toDate, 1);
    //     if (tdate !== '') {
    //         this.toDate = tdate;
    //     } else {
    //         this.toDate = this.endDate;
    //     }
    //     const fdate = this.messageService.ticketConverter(this.fromDate, 1);
    //     if (fdate !== '') {
    //         this.fromDate = fdate;
    //     } else {
    //         this.fromDate = this.startDate;
    //     }
    //     this.filterSearchLoaded = false;
    //     let cats = '';
    //     for (let i = 0; i < this.searchCat.length; i++) {
    //         if (this.searchCat[i].cid !== 0) {
    //             cats += this.searchCat[i].pid + '#' + this.searchCat[i].cid;
    //             if (i !== this.searchCat.length - 1) {
    //                 cats += ',';
    //             }
    //         }
    //     }
    //     // const startDate = this.messageService.ticketConverter(this.startDate, 1);
    //     // const endDate = this.messageService.ticketConverter(this.endDate, 1);
    //     // console.log('this.userGroupSelected============' + this.userGroupSelected);
    //     const data = {
    //         ticketTypeId: this.inciId,
    //         clientId: this.clientId,
    //         supportgrp_id: this.userGroupSelected,
    //         ticketStatusId: this.searchStatusSelected,
    //         ticket_id: 0,
    //         busi_priority_id: 0,
    //         created_frdate: this.fromDate,
    //         created_todate: this.toDate,
    //         catFilterLt: cats,
    //         isTeamLead: 'N',
    //         isDashboardSearch: 0,
    //         ticketTypeSeqNo: 1,
    //         page_size: this.searchPageSize,
    //         nextOffset: this.nextOffset
    //     };
    //     this._rest.AdvancesearchForIncidentTicket(data).subscribe((res) => {
    //         this.respObject = res;
    //         this.filterSearchLoaded = true;
    //         if (this.respObject.success) {
    //             this.gridObj4.getSelectionModel().setSelectedRanges([]);
    //             for (let i = 0; i < this.respObject.details.dataObj.length; i++) {
    //                 this.respObject.details.dataObj[i].createdSince =
    //                     this.messageService.datePipeFunc(this.respObject.details.dataObj[i].createdSince);
    //                 this.respObject.details.dataObj[i].dDate =
    //                     this.messageService.datePipeFunc(this.respObject.details.dataObj[i].dDate);
    //                 this.respObject.details.dataObj[i].updateDate =
    //                     this.messageService.datePipeFunc(this.respObject.details.dataObj[i].updateDate);
    //                 if (this.respObject.details.dataObj[i].closureDate === undefined) {
    //                     this.respObject.details.dataObj[i].closureDate = '';
    //                 } else {
    //                     this.respObject.details.dataObj[i].closureDate =
    //                         this.messageService.datePipeFunc(this.respObject.details.dataObj[i].closureDate);
    //                 }
    //                 this.respObject.details.dataObj[i].requestedDate =
    //                     this.messageService.datePipeFunc(this.respObject.details.dataObj[i].requestedDate);
    //             }
    //             this.addIncidentData = this.respObject.details.dataObj;
    //             if (this.nextOffset === 0) {
    //                 this.gridOptions4.pagination.totalItems = this.respObject.details.totalData[0].count;
    //                 this.totalSearchItems = this.respObject.details.totalData[0].count;
    //             }
    //             this.gridOptions4 = Object.assign({}, this.gridOptions4);
    //         } else {
    //             alert(this.respObject.errorMessage);
    //         }
    //     });
    // }

    onSearchCategoryChange(ticket, option) {
        // // console.log(JSON.stringify(option), typeof option, ticket.id);
        // if(this.ticketTypes)

        const opt = JSON.parse(option);
        if (opt.type !== 'header') {
            // if (this.attachment.length > 0) {
            //   this.attachment = [];
            // }
            const value = opt.id;
            let matched = false;
            const index = this.inciCategories.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            // // // console.log('index:' + index);
            const index1 = this.inciCategories.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            const pid = this.inciCategories[index1].options[0].id;
            // // // console.log(this.ticketTypes[index1].options[0]);
            if (index === 3) {
                const pid1 = this.baseCategories[0].options[1].id;
                const pid2 = this.baseCategories[1].options[1].id;
                const cid1 = this.baseCategories[0].options[0].id;
                const cid2 = this.baseCategories[1].options[0].id;
                if (this.searchCat.length === 0) {
                    this.searchCat.push({ pid: pid1, cid: cid1 }, { pid: pid2, cid: cid2 });
                }
            }
            if (this.searchCat.length === 0) {
                this.searchCat.push({ pid: pid, cid: value });
            } else {
                for (let i = 0; i < this.searchCat.length; i++) {
                    if (this.searchCat[i].pid === pid) {
                        matched = true;
                        this.searchCat[i].cid = value;
                        break;
                    }
                }
                if (!matched) {
                    this.searchCat.push({ pid: pid, cid: value });
                } else {
                    for (let i = index; i < this.searchCat.length; i++) {
                        // // // console.log('matched');
                        // // // console.log(this.cat[i]);
                        if (index > -1) {
                            this.searchCat[i].cid = 0;
                        }
                    }
                }
            }
            // clear sub categories
            if (index > -1) {
                // // console.log('index:' + index);
                for (let i = index + 1; i < this.inciCategories.length; i++) {
                    const options = this.inciCategories[i].options;
                    // // console.log(JSON.stringify(options));
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.inciCategories[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }
            // // // console.log(JSON.stringify(this.cat));
            // // // console.log('index:'+index);
            this._rest.getAttributesParentWiseWithPriority(this.clientId, value, this.priorityId, this.inciId).subscribe((res) => {
                this.respObject = res;
                // // // console.log(JSON.stringify(this.respObject));
                let data;
                if (index > -1) {
                    data = this.inciCategories[index].options[0];
                }
                if (this.respObject.success) {
                    if (this.respObject.details.val) {
                        // data = this.ticketTypes[index].options[0];
                        this.respObject.details.val.unshift(data);
                        this.inciCategories[index].options = this.respObject.details.val;
                    }
                } else {
                    if (index > -1) {
                        this.inciCategories[index].options = [data];
                    }
                    // this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }

    addTicket() {
        for (let i = 0; i < this.selectedTitles4.length; i++) {
            if (this.addedTicket.indexOf(this.selectedTitles4[i]) === -1) {
                this.addedTicket.push(this.selectedTitles4[i]);
            }
        }
        this.ticketCount = this.addedTicket.length;
    }

    onSelectGroup() {
        // // // console.log(typeof this.userGroupSelected);
        if (this.userGroupSelected !== 0) {
            this.userGroupId = this.userGroupSelected;
            for (let i = 0; i < this.userGroups.length; i++) {
                if (this.userGroups[i].groupId === this.userGroupId) {
                    this.groupName = this.userGroups[i].grpName;
                    this.grpLevel = this.userGroups[i].level;
                }
            }
            this.messageService.saveSupportGroup({
                groupId: this.userGroupId,
                grpName: this.groupName,
                level: this.grpLevel
            });
            this.dataset = [];
            this.totalItems = 0;
            this.viewPageload();
        }
    }

    openStatusChangeModal() {
        this.dialogRef1 = this.dialog.open(this.statusChange, {
            width: '400px'
        });
        this.ieTextareaResize();
    }

    changeId($event) {

    }

    searchAllTicket() {
        let searchValue = this.searchText;
        if (this.searchType === 'email' || this.searchType === 'mobile') {
            searchValue = btoa(this.messageService.xorEncode(this.searchText, this.messageService.SECRET_TOKEN));
        }
        this._rest.searchTicket(this.messageService.getUserId(), this.searchType,
            this.searchTypeStatus, searchValue, this.typeChecked, this.userGroupId).subscribe((res1) => {
                this.displayTicket(res1);
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
    }

    selfAssign() {
        const data = {
            id: this.tId,
            supportGroupLevelId: this.userGroupId,
            createdBy: this.messageService.getUserId(),
            refer_user_id: this.messageService.getUserId(),
            cat_id: this.lastCatId,
            parent_cat_id: this.lastParentId,
            frdType: 'Own',
            isDeviation: false,
            WFCClientResultId: this.wfcresultId,
            selected: 1,
            tStatus: this.oldStatusId,
            clientId: this.clientId,
            support_group: this.currentGroup,
            ticketTypeId: this.typeChecked
        };
        this.dataLoaded = false;
        this._rest.updateForwardedTicket(data).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.dataLoaded = true;
                setTimeout(() => {
                    this.onPageLoad('refresh');
                }, 1000);

                // this.wfcresultId = this.respObject.id;
                // if (this.isViewTicket) {
                //     this.folderClick(this.folderClicked);
                // }
                // const UserId = Number(this.messageService.getUserId());
                // for (let i = 0; i <= this.users.length - 1; i++) {
                //     if (UserId === this.users[i].id) {
                //         console.log(this.users[i].name);
                //         this.currentUser = this.users[i].name;
                //         this.aid = this.users[i].id;
                //         break;
                //     }
                //     this.getNextAssignDetails();
                //     this.isCreateTicket = true;
                //     this.getNextStatus();
                //     this.isCreateTicket = false;
                //     this.statusDisabled = false;
                //     this.defaultStatus = false;
                //     this.closedticket = false;
                //     this.isSelfAssignedClicked = true;
                //     this.canForward = true;
                //     this.canAddSolution = true;
                //     this._rest.getTicketStatusForCHRselfAssign(this.tId).subscribe((res) => {
                //         this.respObject = res;
                //         if (this.respObject.success) {
                //             console.log(JSON.stringify(this.respObject.details));
                //             this.statusSeq = this.respObject.details[0].sequence_no;
                //             this.statusName = this.respObject.details[0].ATTRVAL;
                //         } else {
                //             this.notifier.notify('error', this.respObject.errorMessage);
                //         }
                //     }, (err) => {
                //         // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                //     });
                // }
                // alert('Request Forwarded successfully');
                // this.terminateWorker();

            } else {
                this.dataLoaded = true;
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }

    submitStatus() {
        if (this.dialogRef1) {
            this.dialogRef1.close();
        }
        const data = {
            id: this.wfcresultId,
            tStatus: this.statusSelected,
            user_id: this.messageService.getUserId(),
            ticketId: this.tId,
            clientId: this.clientId,
            feedback: this.statusComment.trim(),
            support_group: this.currentGroup,
            ticketTypeId: this.typeChecked,
            cat_id: this.lastCatId
        };
        // if (this.statusComment !== null && this.statusComment !== '' && this.statusComment !== undefined) {
        //     data['feedback'] = this.statusComment;
        // }
        const userSelected = true;
        if (this.isFollowUp) {
            // if (this.followUpSelected === 0) {
            //     alert('Please select a follow up user before changing status');
            //     userSelected = false;
            // } else {
            data['followupUserId'] = 4209;
            // }
        }
        if (userSelected) {
            this.dataLoaded = false;
            this.statusComment = '';
            this._rest.updateTicketStatus(data).subscribe((res1) => {
                this.respObject = res1;
                this.dataLoaded = true;
                if (this.respObject.success) {
                    alert('Status Changed Successfully');
                    this.statusName = this.status[this.statusIndex].name;
                    this.statusSeq = this.status[this.statusIndex].seq;
                    if (this.statusSeq !== this.FOLLOW_UP_SEQ && this.statusSeq !== this.INERNAL_GUIDANCE_PROVIDED) {
                        this.modalReference.close();
                        if (this.isViewTicket) {
                            this.folderClick(this.folderClicked);
                        }
                    } else {
                        this.oldStatusId = this.statusSelected;
                        // this.isFollowUp = false;
                        // this.statusClick();
                        this.getNextStatus();
                        // this.defaultStatus = true;
                        this.statusDisabled = false;
                        this.defaultStatus = false;
                        this.closedticket = false;
                        // this.statusClick('open');
                        this.getComments();
                        this._rest.getLatestWFCRId(this.tId).subscribe((res) => {
                            this.respObject = res;
                            if (this.respObject.success) {
                                this.wfcresultId = this.respObject.details[0].id;
                            } else {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            }
                        }, (err) => {
                            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                        });
                        this._rest.getTicketDetail(this.tId).subscribe((res) => {
                            this.respObject = res;
                            if (this.respObject.success) {
                                this.dDate = this.messageService.datePipeFunc(this.respObject.details[0].dueDate);
                                this.lastComment = this.respObject.details[0].lastComment;
                                this.lastCommentUser = this.respObject.details[0].lastCommentUser;
                            } else {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            }
                        }, (err) => {
                            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                        });
                    }
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // alert(this.messageService.SERVER_ERROR);
            });
        }
    }


    getNextStatus() {
        this._rest.getStatusClientSSC(this.messageService.getUserId(), this.clientId, this.tId,
            this.typeChecked).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    // // // console.log(JSON.stringify(this.respObject.details.cat));
                    this.respObject.details.unshift({ id: 0, name: 'Select Status' });
                    this.status = this.respObject.details;
                    this.statusSelected = 0;
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
    }

    changeStatus() {
        if (this.statusComment === null || this.statusComment.trim() === '' || this.statusComment === undefined) {
            alert(this.messageService.BLANK_COMMENT);

        } else {
            this.submitStatus();
        }
    }

    setStatus() {
        if (this.statusSelected === 0) {
            alert(this.messageService.BLANK_STATUS);
        } else {
            this.statusComment = '';
            if (this.isCommentRequired === 'N') {
                this.submitStatus();
            } else {
                this.openStatusChangeModal();
            }
        }
    }

    onStatusChange(selectedIndex: any) {
        this.statusIndex = selectedIndex;
        this.isCommentRequired = this.status[this.statusIndex].is_command_required;
        // if (this.status[this.statusIndex].seq === this.FOLLOW_UP_SEQ) {
        //     this.getFollowUp();
        //     this.isFollowUp = true;
        // } else {
        //     this.isFollowUp = false;
        // }
    }

    saveAssetData() {
        const ids = [];
        for (let i = 0; i < this.selectedTitles2.length; i++) {
            ids.push(this.selectedTitles2[i].id);
        }
        this._rest.insertAssetIds({
            ticketId: this.tId,
            WFCClientResultId: this.wfcresultId,
            assetIds: ids,
            createdBy: this.messageService.getUserId()
        }).subscribe((res1) => {
            this.respObject = res1;
            // // // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
                alert('Data Successfully saved');
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }

    ieTextareaResize() {
        if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
            const el = document.getElementsByClassName('ie-textarea');
            // console.log('el=============', el);
            //resizePolyfill(el, true);
        }
    }

    tabClick(event) {
        this.terminateWorker();
        if (event.tab.textLabel === 'Comments') {
            // this.getComments();
            this.ieTextareaResize();
            const data = {
                ticketId: this.tId,
                groupId: this.userGroupId,
                user_id: this.messageService.getUserId(),
                type: 'cmmnt',
                clientId: this.clientId
            };
            if (this.displayNewComment) {
                this._rest.updateOfflineNotificationData(data).subscribe((res2) => {
                    this.respObject = res2;
                    if (this.respObject.success) {

                    }
                });
            }
            this.displayNewComment = false;
        } else if (event.tab.textLabel === 'SLA Meter') {
            this.getSLAPercentage();
            if (Worker) {
                this.worker = new Worker('../assets/worker/worker.js');
                this.onmessage();
                this.worker.postMessage({
                    url: this._rest.apiRoot + '/getSlaCompletionPercentage?ticketId=' + this.tId + '&user_id=' +
                        this.messageService.getUserId() + '&mapping_client_config_id=' + this.clientId,
                    event: 'slaPercentage', time: this.SLA_INTERVAL_TIME, token: this.messageService.getToken()
                });
            }
        } else if (event.tab.textLabel === 'Activity Logs') {
            this._rest.getLogsTicketWise(this.tId).subscribe((res1) => {
                this.respObject = res1;
                // // // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                    this.logs = this.respObject.details;
                } else {
                    // this.notifier.notify('error', this.respObject.errorMessage);
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else if (event.tab.textLabel === 'Solutions') {
            // this.displayNewSolutions = false;
            this.getSolutions();
            this.ieTextareaResize();
            const data = {
                ticketId: this.tId,
                groupId: this.userGroupId,
                user_id: this.messageService.getUserId(),
                type: 'slprvd',
                clientId: this.clientId
            };
            if (this.displayNewSolutions) {
                this._rest.updateOfflineNotificationData(data).subscribe((res2) => {
                    this.respObject = res2;
                    if (this.respObject.success) {

                    }
                });
            }
            this.displayNewSolutions = false;
        } else if (event.tab.textLabel === 'Attachments') {
            // this.displayNewAttachment = false;
            this._rest.getAttachmentTicketWise(this.tId).subscribe((res1) => {
                this.respObject = res1;
                // // // console.log(JSON.stringify(this.respObject));
                this.attachments = [];
                if (this.respObject.success) {
                    // for (let i = 0; i < this.respObject.details.length; i++) {
                    //     this.respObject.details[i].attacheMent = this.messageService.UPLOAD_PATH +
                    //         this.respObject.details[i].attachedFilePath;
                    // }
                    this.attachments = this.respObject.details;
                } else {
                    // this.notifier.notify('error', this.respObject.errorMessage);
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
            const data = {
                ticketId: this.tId,
                groupId: this.userGroupId,
                user_id: this.messageService.getUserId(),
                type: 'attchmnt',
                clientId: this.clientId
            };
            if (this.displayNewAttachment) {
                this._rest.updateOfflineNotificationData(data).subscribe((res2) => {
                    this.respObject = res2;
                    if (this.respObject.success) {

                    }
                });
            }
            this.displayNewAttachment = false;

        } else if (event.tab.textLabel === 'View Asset Details') {
            this.columnDefinitions1 = [{
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            }];
            this.showGrid = true;
            this._rest.getAssetMasterByTicket(this.tId).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    const dataArr = this.respObject.details;
                    this.masterNameObj = dataArr;
                    this.masterNameObj.unshift({ id: 0, masterName: 'Select asset master name' });
                    this.totalData = dataArr.length;
                    this.masterNameSelected = 0;
                    if (this.gridObj1) {
                        this.gridObj1.invalidateAllRows();
                    }
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else if (event.tab.textLabel === 'Add Asset Details') {
            this.columnDefinitions2 = [{
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            }];
            this.showGrid1 = true;
            this._rest.getAssetManagementMaster(this.clientId).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    const dataArr = this.respObject.details;
                    // // // console.log('master data=', dataArr);
                    this.masterNameObj = dataArr;
                    this.masterNameObj.unshift({ id: 0, masterName: 'Select asset master name' });
                    this.totalData = dataArr.length;
                    this.masterDataNameSelected = 0;
                    if (this.gridObj2) {
                        this.gridObj2.invalidateAllRows();
                    }
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else if (event.tab.textLabel === 'View Incident') {
            this.columnDefinitions3 = [{
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            }];
            this.showGridForViewIncident = true;
            this._rest.getMappedIncidentTicketDetails(this.clientId, this.inciId, this.tId).subscribe((res2) => {
                this.respObject = res2;
                if (this.respObject.success) {
                    const data = this.respObject.details[0];
                    const data1 = [];

                    // // // console.log(JSON.stringify(data));
                    const columnDef = [
                        { id: 'id', name: 'Id', field: 'id', minWidth: 100, sortable: true, filterable: true },
                        {
                            id: 'ticket_id',
                            name: 'Request Id',
                            field: 'ticket_id',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'createdBy',
                            name: 'Created By',
                            field: 'createdBy',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'createdSince',
                            name: 'Created On',
                            field: 'createdSince',
                            minWidth: 100,
                            sortable: true,
                            filterable: true,
                            type: FieldType.dateIso
                        },
                        {
                            id: 'status',
                            name: 'Status',
                            field: 'status',
                            sortable: true,
                            minWidth: 100,
                            filterable: true
                        },
                        {
                            id: 'reqInfo',
                            name: 'Requester Info',
                            field: 'reqInfo',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'priority',
                            name: 'Priority',
                            field: 'priority',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'assignee',
                            name: 'Assignee',
                            field: 'assignee',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'LEVELSHORTDESC',
                            name: 'Group',
                            field: 'LEVELSHORTDESC',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'dDate',
                            name: 'Due Date',
                            field: 'dDate',
                            minWidth: 100,
                            sortable: true,
                            filterable: true,
                            type: FieldType.dateIso
                        },
                        {
                            id: 'updateDate',
                            name: 'Last Update Date',
                            field: 'updateDate',
                            minWidth: 100,
                            sortable: true,
                            filterable: true,
                            type: FieldType.dateIso
                        },
                        {
                            id: 'updateBy',
                            name: 'Last Updated By',
                            field: 'updateBy',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'closureDate',
                            name: 'Closure Date',
                            field: 'closureDate',
                            minWidth: 100,
                            sortable: true,
                            filterable: true,
                            type: FieldType.dateIso
                        }
                    ];
                    for (let i = 0; i < this.columnData3.length; i++) {
                        data1.push(this.columnData3[i]);
                    }
                    for (let i = 0; i < columnDef.length; i++) {
                        data1.push(columnDef[i]);
                    }
                    for (let i = 0; i < data.length; i++) {
                        data1.push({
                            id: data[i].field,
                            name: data[i].name,
                            field: data[i].field,
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        });
                    }
                    this.gridObj3.setColumns(data1);
                    for (let i = 0; i < this.respObject.details[1].length; i++) {
                        this.respObject.details[1][i].createdSince =
                            this.messageService.datePipeFunc(this.respObject.details[1][i].createdSince);
                        this.respObject.details[1][i].dDate =
                            this.messageService.datePipeFunc(this.respObject.details[1][i].dDate);
                        this.respObject.details[1][i].updateDate =
                            this.messageService.datePipeFunc(this.respObject.details[1][i].updateDate);
                        if (this.respObject.details[1][i].closureDate === undefined) {
                            this.respObject.details[1][i].closureDate = '';
                        } else {
                            this.respObject.details[1][i].closureDate =
                                this.messageService.datePipeFunc(this.respObject.details[1][i].closureDate);
                        }
                        this.respObject.details[1][i].requestedDate =
                            this.messageService.datePipeFunc(this.respObject.details[1][i].requestedDate);
                    }
                    this.viewIncidentData = this.respObject.details[1];
                    // const classes = document.getElementsByClassName('search-filter');
                    // for (let i = 0; i < classes.length; i++) {
                    //   classes[i].setAttribute('placeholder', '');
                    // }
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // alert(this.messageService.SERVER_ERROR);
            });
        } else if (event.tab.textLabel === 'Add Incident') {
            this.ticketIdSearchLoaded = true;
            this.filterSearchLoaded = true;
            this.categoryLoaded = false;
            this.getIncidentCategory();
            this._rest.getStatusByTicketTypeLt(1, this.clientId).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.respObject.details.unshift({ id: 0, status: 'Select Status' });
                    this.allStatus = this.respObject.details;
                    this.searchStatusSelected = 0;
                }
            });
            // =================================================================
            // ===============================================================
            this.ticketCount = 0;
            this.addedTicket = [];
            this.showGridForAddIncident = true;
            this._rest.getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.inciId).subscribe((res2) => {
                this.respObject = res2;
                if (this.respObject.success) {
                    const data = this.respObject.details;
                    const data1 = [];

                    // // // console.log(JSON.stringify(data));
                    const columnDef = [
                        { id: 'id', name: 'Id', field: 'id', minWidth: 100, sortable: true, filterable: true },
                        {
                            id: 'ticket_id',
                            name: 'Request Id',
                            field: 'ticket_id',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'createdBy',
                            name: 'Created By',
                            field: 'createdBy',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'createdSince',
                            name: 'Created On',
                            field: 'createdSince',
                            minWidth: 100,
                            sortable: true,
                            type: FieldType.dateIso,
                            filterable: true
                        },
                        {
                            id: 'status',
                            name: 'Status',
                            field: 'status',
                            sortable: true,
                            minWidth: 100,
                            filterable: true
                        },
                        {
                            id: 'reqInfo',
                            name: 'Requester Info',
                            field: 'reqInfo',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'priority',
                            name: 'Priority',
                            field: 'priority',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'assignee',
                            name: 'Assignee',
                            field: 'assignee',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'LEVELSHORTDESC',
                            name: 'Group',
                            field: 'LEVELSHORTDESC',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'dDate',
                            name: 'Due Date',
                            field: 'dDate',
                            minWidth: 100,
                            sortable: true,
                            filterable: true,
                            type: FieldType.dateIso
                        },
                        {
                            id: 'updateDate',
                            name: 'Last Update Date',
                            field: 'updateDate',
                            minWidth: 100,
                            sortable: true,
                            filterable: true,
                            type: FieldType.dateIso
                        },
                        {
                            id: 'updateBy',
                            name: 'Last Updated By',
                            field: 'updateBy',
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        },
                        {
                            id: 'closureDate',
                            name: 'Closure Date',
                            field: 'closureDate',
                            minWidth: 100,
                            sortable: true,
                            filterable: true,
                            type: FieldType.dateIso
                        }
                    ];
                    for (let i = 0; i < this.columnData4.length; i++) {
                        data1.push(this.columnData4[i]);
                    }
                    for (let i = 0; i < columnDef.length; i++) {
                        data1.push(columnDef[i]);
                    }
                    for (let i = 0; i < data.length; i++) {
                        data1.push({
                            id: data[i].field,
                            name: data[i].name,
                            field: data[i].field,
                            minWidth: 100,
                            sortable: true,
                            filterable: true
                        });
                    }
                    this.gridObj4.setColumns(data1);

                    // this.addIncidentData = [];
                    this.gridObj4.getSelectionModel().setSelectedRanges([]);
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // alert(this.messageService.SERVER_ERROR);
            });
        } else if (event.tab.textLabel === 'Requestor Info') {
            // const element = document.getElementById('requestor-info');
            if (this.psInfo.length === 0) {
                this._rest.getRequesterInfo(this.messageService.getUserId(), this.tId).subscribe((res1) => {
                    this.respObject = res1;
                    // this.dialog.closeAll();
                    if (this.respObject.success) {
                        if (this.respObject.details.length > 0) {
                            this.psInfo.push(this.valueNullCheck(this.respObject.details[0]));
                        }
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });
            }
        } else if (event.tab.textLabel === 'User\'s Reply') {
            // this.replyAttachment = [];
            this.replyHideAttachment = true;
            // this.getLastComment();
        }
    }

    getLastComment() {
        this._rest.getLastCommentByTicketId(this.messageService.getUserId(), this.tId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                if (this.respObject.details.length > 0) {
                    this.lastComment = this.respObject.details[0].feedback;
                    this.lastCommentUser = this.respObject.details[0].name;
                }
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    getIncidentCategory() {
        const cat = this.messageService.getCategory1();
        this._rest.getTicketCreateLoadingDtls_lnt(this.messageService.getUserId(), this.inciId, this.clientId,
            cat.cat1, cat.cat2).subscribe((res) => {
                this.respObject = res;
                this.categoryLoaded = true;
                if (this.respObject.success) {
                    this.inciCategories = this.messageService.copyArray(this.respObject.details[0].attribute);
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
    }

    nullCheck(value) {
        if (value === null || value === 'null') {
            return 'N/A';
        } else {
            return value;
        }
    }

    valueNullCheck(data) {
        const psObj = {};
        for (const k in data) {
            psObj[k] = this.nullCheck(data[k]);
        }
        // this.psInfo.push(psObj);
        return psObj;
    }

    submitUserReply() {
        if (this.usersReply && this.usersReply.trim() !== '') {
            const data = {
                'ticketId': this.tId,
                'WFCClientResultId': this.wfcresultId,
                'feedback': this.usersReply.trim(),
                'createdBy': this.messageService.getUserId(),
                'user_id': this.messageService.getUserId(),
                'clientId': this.clientId,
                'attachmentPath': this.replyAttachment,
                'support_group': this.currentGroup
            };
            // // // console.log(JSON.stringify(data));
            this.dataLoaded = false;
            this.usersReply = '';
            console.log(JSON.stringify(data));
            this._rest.submitUserReplyFotTicketIfo(data).subscribe((res1) => {
                this.respObject = res1;
                // // // console.log(JSON.stringify(this.respObject));
                this.dataLoaded = true;
                if (this.respObject.success) {
                    this.activateUserReplay = false;
                    this.replyHideAttachment = true;
                    this.replyAttachment = [];

                    this.terminateWorker();
                    this.modalReference.close();
                } else {
                    this.notifier.notify('error', this.respObject.errorMessage);
                }
            }, (err) => {
            });
        } else {
            alert(this.messageService.BLANK_COMMENT);
        }
    }

    onMasterChange(value: any) {
        this.masterName = this.masterNameObj[value].masterName;
        // =================================== get column and column value details================================
        this._rest.getTicketWiseAssetData(this.tId, this.masterNameSelected).subscribe((res) => {
            this.respObject = res;
            // // // console.log(this.respObject)
            if (this.respObject.success) {
                this.gridObj1.getSelectionModel().setSelectedRanges([]);
                this.data = [];
                const data1 = [];
                for (let i = 0; i < this.columnData.length; i++) {
                    data1.push(this.columnData[i]);
                }
                const data = this.respObject.details;
                const columnNameObj = data.columnObj;
                const columnValueObj = data.valueObj;
                data1.push({ id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true });
                for (let i = 0; i < columnNameObj.length; i++) {
                    data1.push({
                        id: columnNameObj[i].columnName,
                        name: columnNameObj[i].columnName,
                        field: columnNameObj[i].id,
                        sortable: true,
                        filterable: true
                    });

                }
                this.gridObj1.setColumns(data1);
                const colval = [];
                for (let j = 0; j < columnValueObj.length; j++) {
                    const columVal = columnValueObj[j].columVal;
                    const descId = columnValueObj[j].id;
                    const columnValue = columVal.split(',');
                    // // // console.log('column=', JSON.stringify(columnValue));
                    const jsonval = {};
                    jsonval['id'] = descId;
                    for (let k = 0; k < columnValue.length; k++) {
                        const attrVal = columnValue[k];
                        const attrValue = attrVal.split(':');

                        jsonval[attrValue[0]] = attrValue[1];
                    }
                    colval.push(jsonval);
                }
                this.data = colval;


            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
        // =============================================================================================================
    }

    getFollowUp() {
        const data = {
            user_id: this.messageService.getUserId(),
            ticketTypeId: this.typeChecked,
            busi_priority_id: this.priorityId,
            category_id: this.lastCatId,
            tStatus: this.statusSelected,
            clientId: this.clientId,
            ticketId: this.tId
        };
        this._rest.getFollowupUserLt(data).subscribe((res4) => {
            this.respObject = res4;
            if (this.respObject.success) {
                // // // console.log(this.respObject);
                this.respObject.details.unshift({ id: 0, followup_users_name: 'Status' });
                this.followUps = this.respObject.details;
                this.followUpSelected = 0;
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
        });
    }

    onTicketChange(ticket, option) {
        const opt = JSON.parse(option);
        // console.log(JSON.stringify(option));
        if (opt.type !== 'header') {
            const value = opt.id;
            let matched = false;
            const index = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id + 1);
            const index1 = this.ticketTypes.map(function (d) {
                return d['id'];
            }).indexOf(ticket.id);
            // // console.log(index1, index);
            // let pid;
            // if (index1 > 0) {
            //   // // console.log(JSON.stringify( this.ticketTypes[index1]))
            //   // // console.log(JSON.stringify( this.ticketTypes[index1].options))
            //     pid = this.ticketTypes[index1].options[0].id;
            // } else {
            //   pid = this.ticketTypes[index1].options[1].id;
            // }
            // const pid = this.ticketTypes[index1].id;
            let pid;
            // // console.log(this.ticketTypes[index1].options[0]);
            if (index1 === this.disabledCount) {
                // const pid1 = this.baseCategories[0].options[1].id;
                pid = this.baseCategories[this.disabledCount].options[1].id;
                // console.log(pid,this.disabledCount );
                // const cid1 = this.baseCategories[0].options[0].id;
                if (this.cat.length === 0) {
                    let pid1, cid1;
                    for (let i = 0; i < this.disabledCount; i++) {
                        pid1 = this.baseCategories[i].options[1].id;
                        cid1 = this.baseCategories[i].options[0].id;
                        this.cat.push({ pid: pid1, cid: cid1 });
                    }
                    // this.cat.push({pid: pid1, cid: cid1});
                }
            } else {
                pid = this.ticketTypes[index1].options[0].id;
            }
            // console.log('pid:' + pid);
            // // console.log('1');
            if (this.cat.length === 0) {
                this.cat.push({ pid: pid, cid: value });
            } else {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].pid === pid) {
                        matched = true;
                        this.cat[i].cid = value;
                        break;
                    }
                }
                if (!matched) {
                    this.cat.push({ pid: pid, cid: value });
                } else {
                    for (let i = index; i < this.cat.length; i++) {
                        if (index > -1) {
                            this.cat[i].cid = 0;
                        }
                    }
                }
            }
            // // console.log('---->' + JSON.stringify(this.cat));
            // // console.log(value);
            let data;
            if (index > -1) {
                for (let i = 0; i < this.ticketTypes[index].options.length; i++) {
                    if (this.ticketTypes[index].options[i].type) {
                        data = this.ticketTypes[index].options[i];
                    }
                }
            }
            if (index > -1) {
                for (let i = index + 1; i < this.ticketTypes.length; i++) {
                    const options = this.ticketTypes[i].options;
                    for (let j = 0; j < options.length; j++) {
                        if (options[j].type) {
                            // options=[];
                            this.ticketTypes[i].options = [options[j]];
                            break;
                        }
                    }
                }
            }
            if (index === 4) {
                if (this.seq === this.INCIDENT_TYPE_SEQ) {
                    this.displayClaimNo = opt.attachedField;
                }
            }
            // // // console.log(JSON.stringify(this.ticketTypes), ticket.id);
            if (ticket.id === 1) {
                if (value === Number(this.lastCatId)) {
                    this._rest.getAddionalFieldWithValue(this.tId).subscribe((res) => {
                        this.respObject = res;
                        if (this.respObject.success) {
                            // // // console.log(JSON.stringify(this.respObject.details));
                            for (let i = 0; i < this.respObject.details.length; i++) {
                                if (this.respObject.details[i].predifinedValue !== null) {
                                    this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
                                }
                            }
                            this.dynamicFields = this.respObject.details;
                        } else {
                            // this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } else {
                    this._rest.getTicketFieldsCatWise({
                        clientId: this.clientId,
                        catId: value,
                        ticketTypeId: this.typeChecked
                    }).subscribe((res) => {
                        this.respObject = res;
                        if (this.respObject.success) {
                            // // console.log(JSON.stringify(this.respObject.details));
                            for (let i = 0; i < this.respObject.details.length; i++) {
                                if (this.respObject.details[i].predifinedValue !== null) {
                                    this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
                                    this.respObject.details[i].value = this.respObject.details[i].values[0];
                                } else {
                                    this.respObject.details[i].value = '';
                                }
                            }
                            this.dynamicFields = this.respObject.details;
                        } else {
                            // this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                }

            }
            if (index > -1) {
                this.ticketTypes[index].options = [data];
                this.dataLoaded = false;
            }
            this._rest.getAttributesParentWise(this.clientId, value).subscribe((res) => {
                this.respObject = res;

                if (this.respObject.success) {
                    this.dataLoaded = true;
                    this.respObject.details.unshift(data);
                    // // // console.log(JSON.stringify(this.respObject.details));
                    this.ticketTypes[index].options = this.respObject.details;
                } else {
                    // this.notifier.notify('error', this.respObject.errorMessage);
                    // if (this.respObject.errorMessage === 'No data found') {
                    //     this.ticketTypes[index].options = [data];
                    // }
                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        }
    }

    statusClick(type) {
        // console.log('11111111111111111111111111111111111111111111111111111111');
        if (!this.statusDisabled) {
            // console.log('sdfssssssssssssssssssssssss');
            this.defaultStatus = !this.defaultStatus;
            this.isFollowUp = false;
        }


    }

    userClick(type) {
        if (this.assignedToMe && !this.escalatedTicket) {
            this.defaultUser = !this.defaultUser;
            this.userSelected = 0;
            if (this.groupDetails) {
                if (type === 'close') {
                    if (this.supportGroupSelected === this.groupDetails.groupId) {
                        this.userSelected = this.groupDetails.userId;
                    } else {
                        this.userSelected = 0;
                    }
                } else {
                    this.userSelected = 0;
                }
            } else {
                if (this.supportGroupSelected === this.gid) {
                    this.userSelected = this.aid;
                } else {
                    this.userSelected = 0;
                }
                // this.supportGroupSelected = 0;
            }
            // // console.log('userCancel: ' + this.userSelected);
        }
    }

    nextUserClick(type) {
        if (this.assignedToMe && this.aGrpLvl > 0) {
            this.defaultNextUser = !this.defaultNextUser;
            if (this.groupDetails) {
                // // console.log('inside if');
                this.supportGroupSelected = this.groupDetails.groupId;
                this.gid_copy = this.groupDetails.groupId;
                if (type === 'close') {
                    // // // console.log('close' + this.groupDetails.userId);
                    this.userSelected = this.groupDetails.userId;
                    this.currentUser = this.assignee_copy;
                    this.gid_copy = this.gid;
                    // // console.log('closed');
                    // // console.log('------>' + JSON.stringify(this.users_copy));
                    this.users = this.messageService.copyArray(this.users_copy);
                } else {
                    this.userSelected = 0;
                    this.currentUser = 'No User Assigned';
                    this.getUser(this.supportGroupSelected);
                }
            } else {
                // // console.log('inside else');
                this.supportGroupSelected = 0;
                this.userSelected = this.aid;
                this.users = this.messageService.copyArray(this.users_copy);
            }

            // // console.log('groupCancel: ' + this.supportGroupSelected);
            // this.getUser(this.supportGroupSelected);
        }
    }

    updateTicket() {
        let cats = '';
        let extrafields = '';
        let isError = false;
        if (this.cat.length > 0) {
            if (this.cat.length === this.ticketTypes.length) {
                for (let i = 0; i < this.cat.length; i++) {
                    if (this.cat[i].cid !== 0) {
                        cats += this.cat[i].pid + '#' + this.cat[i].cid;
                        if (i !== this.cat.length - 1) {
                            cats += ',';
                        }
                    } else {
                        isError = true;
                        break;
                    }
                }
            } else {
                isError = true;
            }
        }
        // // console.log(cats);
        if (isError) {
            alert(this.messageService.CATEGORY_ERROR);
        } else {
            // // console.log(this.cat.length);
            for (let i = 0; i < this.dynamicFields.length; i++) {
                if (this.dynamicFields[i].value !== '' && this.dynamicFields[i].value !== 'NONE') {
                    if (i === this.dynamicFields.length - 1) {
                        extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value;
                    } else {
                        extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value + '#';
                    }
                }
            }
            extrafields = extrafields.substring(extrafields.length - 1, extrafields.length) === '#'
                ? extrafields.substring(0, extrafields.length - 1) : extrafields;
            const data = {
                'id': this.tId,
                'requesterInfo': this.name,
                'tName': this.desc,
                'longDesc': this.brief,
                'attachedFilePath': this.attachment,
                'requestedDate': new Date(this.rDate),
                'dueDate': new Date(this.dDate),
                'WFCClientResultId': this.wfcresultId,
                'createdBy': this.messageService.getUserId(),
                'clientId': this.clientId,
                'ticketTypeId': this.typeChecked,
                'ticket_type_seq': this.seq,
                'priorityId': this.priorityId
            };
            if (extrafields !== '') {
                data['fieldValueDtls'] = extrafields;
            }
            if (this.displayClaimNo) {
                data['claimNo'] = this.claimNo;
                if (this.claimNo.trim() === '') {
                    this.isBlankClaim = true;
                } else {
                    this.isBlankClaim = false;
                }
            }
            // console.log('this.isBlankClaim:' + this.isBlankClaim);
            if (this.seq === this.PROBLEM_TYPE_SEQ) {
                delete data.requesterInfo;
            }
            if (this.cat.length > 0) {
                data['categoryDtlsLt'] = cats;
            }

            if (this.desc.trim() === '') {
                this.isBlankDesc = true;
            } else {
                this.isBlankDesc = false;
            }
            if (this.brief.trim() === '') {
                this.isBlankLong = true;
            } else {
                this.isBlankLong = false;
            }
            // console.log(JSON.stringify(data));
            if (!this.messageService.isBlankField(data)) {
                if (this.cat.length === 0) {
                    data['categoryDtlsLt'] = '';
                }
                // const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
                if (this.attachFile > 0) {
                    alert(this.messageService.UPLOAD_ALERT_BEFORE_UPDATE);
                } else {
                    this.dataLoaded = false;
                    this._rest.updateTicket(data).subscribe((res1) => {
                        this.respObject = res1;
                        this.dataLoaded = true;
                        // // console.log(JSON.stringify(this.respObject));
                        if (this.respObject.success) {
                            this.attachment = [];
                            this.hideAttachment = true;
                            alert('Request Updated Successfully');
                            this.modalReference.close();
                        } else {
                            alert(this.respObject.errorMessage);
                        }
                    }, (err) => {
                        // alert(this.messageService.SERVER_ERROR);
                    });
                }
            } else {
                alert(this.messageService.BLANK_ERROR_MESSAGE);
            }
        }
    }

    onFileError(msg: string) {
        alert(msg);
    }

    // @HostListener('window:scroll', [])
    // onScroll(): void {
    //     // console.log('scroll')
    //     const elemData = document.getElementById('viewGrid');
    //     if ((window.innerHeight + window.scrollY) >= elemData.offsetHeight) {
    //         // console.log('---------------- end of body----------------');
    //     }
    // }
    forwardTicketWithMessage() {
        if (this.userSelected > 0) {
            this.commentDialogRef = this.dialog.open(this.addCommentMessage, {
                width: '500px'
            });
        } else {
            alert(this.messageService.BLANK_ASSIGNE_USER);
        }
    }

    addComment(type) {
        // if (this.aid === undefined) {
        //   alert(this.messageService.BLANK_USER);
        // } else {
        if (this.comment && this.comment.trim() !== '') {
            const data = {
                ticketId: this.tId,
                WFCClientResultId: this.wfcresultId,
                createdBy: this.messageService.getUserId(),
                feedback: this.comment.trim(),
                clientId: this.clientId,
                cat_id: this.lastCatId,
                ticketTypeId: this.typeChecked
            };
            // // // console.log(JSON.stringify(data));
            this.comLoaded = false;
            this.canAddComment = false;
            this._rest.submitFeedbackTicketWise(data).subscribe((res1) => {
                this.respObject = res1;
                this.comLoaded = true;
                this.canAddComment = true;
                if (this.respObject.success) {
                    this.comment = '';
                    if (type === 'comment') {
                        this.getComments();
                    } else if (type === 'forward') {
                        this.commentDialogRef.close();
                        this.forwardTicket();
                    }
                } else {
                    alert(this.respObject.errorMessage);


                }
            }, (err) => {
                // this.notifier.notify('error', this.messageService.SERVER_ERROR);
            });
        } else {
            alert(this.messageService.BLANK_COMMENT);
            console.log('AAAAAA');
        }
        // }
    }

    addSolution() {
        if (this.aid === undefined) {
            alert(this.messageService.BLANK_USER_SOLUTION);
        } else {
            if (this.statusSeq !== 1) {
                if (this.solution && this.solution.trim() !== '') {
                    const data = {
                        ticketId: this.tId,
                        WFCClientResultId: this.wfcresultId,
                        createdBy: this.messageService.getUserId(),
                        solutions: this.solution.trim(),
                        clientId: this.clientId,
                        rca: '',
                        ticket_type_seq: this.seq,
                        seq_no: 2
                    };
                    this.solLoaded = false;
                    this.solution = '';
                    this.dataLoaded = false;
                    this._rest.submitSolutionsTicketWise(data).subscribe((res1) => {
                        this.respObject = res1;
                        this.solLoaded = true;
                        this.dataLoaded = true;
                        if (this.respObject.success) {
                            this.solution = '';
                            if (this.isViewTicket) {
                                this.folderClick(this.folderClicked);
                            }
                            alert('Solution Provided successfully');
                            // if (this.slaTime) {
                            //   clearInterval(this.slaTime);
                            // }
                            this.terminateWorker();
                            this.modalReference.close();
                            // this.getSolutions();
                        } else {
                            alert(this.respObject.errorMessage);
                        }
                    }, (err) => {
                        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } else {
                    alert(this.messageService.BLANK_SOLUTION);
                }
            } else {
                alert(this.messageService.CHANGE_STATUS);
            }
        }
    }

    forwardTicket() {
        if (this.statusSeq === 105) {
            const data = {
                clientId: this.clientId,
                id: this.tId,
                createdBy: this.messageService.getUserId(),
                cat_id: this.lastCatId,
                parent_cat_id: this.lastParentId,
                ticketTypeId: this.typeChecked
            };
            this._rest.forwardProblemTicketAfterChangesToApprover(data).subscribe((res1) => {
                this.respObject = res1;
                // // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                    if (this.isViewTicket) {
                        this.folderClick(this.folderClicked);
                    }
                    alert('Request Forwarded successfully');
                    // if (this.slaTime) {
                    //   clearInterval(this.slaTime);
                    // }
                    this.terminateWorker();
                    this.modalReference.close();
                } else {
                    alert(this.respObject.errorMessage);
                    console.log('aaaaaa');
                }
            }, (err) => {
                // alert(this.messageService.SERVER_ERROR);
            });
        } else {

            // console.log('inside forward:' + this.supportGroupSelected, this.userSelected);
            // console.log('gid:' + this.gid, this.gid_copy);
            // console.log('aid:' + this.aid);
            let selfAssignNeeded = false;
            if (this.seq === this.INCIDENT_TYPE_SEQ) {
                if (this.statusSeq === 1 && Number(this.userSelected) !== Number(this.messageService.getUserId())) {
                    selfAssignNeeded = true;
                }
            } else {
                if (this.aid === undefined) {
                    if (Number(this.userSelected) !== Number(this.messageService.getUserId())) {
                        selfAssignNeeded = true;
                    }
                }
            }

            if (selfAssignNeeded) {
                alert(this.messageService.SELF_ASSIGN);
                this.selfAssign();

            } else {
                let type = '', isDeviation = false, userChange = false;
                // // console.log(this.groupDetails);
                if (this.groupDetails) {
                    // // console.log('first if');
                    if (this.userSelected !== this.groupDetails.userId) {
                        // // console.log('first if if');
                        if (this.gid_copy === this.gid) {
                            // // console.log('first if if1 if');
                            type = 'Own';
                            this.supportGroupSelected = this.gid;
                        }
                    }
                    if (this.supportGroupSelected !== this.groupDetails.groupId && type !== 'Own') {
                        // // console.log('first if if2 if');
                        isDeviation = true;
                    }
                } else {
                    // // console.log('first else');
                    if (this.userSelected !== this.aid && this.userSelected !== 0) {
                        // // console.log('first else if');
                        userChange = true;
                        if (this.supportGroupSelected === 0) {
                            type = 'Own';
                            this.supportGroupSelected = this.gid;
                        }
                    }
                    if (type !== 'Own') {
                        isDeviation = true;
                    }
                }
                // console.log('type: ' + type);
                // if (this.aid === undefined && type !== 'Own') {
                //     alert(this.messageService.BLANK_USER);
                // } else {
                // // console.log(isDeviation, this.supportGroupSelected);
                if (this.assignedToMe) {
                    if (this.userSelected === 0) {
                        this.userSelected = null;
                    }
                    const data = {
                        id: this.tId,
                        supportGroupLevelId: this.supportGroupSelected,
                        createdBy: this.messageService.getUserId(),
                        refer_user_id: this.userSelected,
                        cat_id: this.lastCatId,
                        parent_cat_id: this.lastParentId,
                        frdType: type,
                        isDeviation: isDeviation,
                        WFCClientResultId: this.wfcresultId,
                        tStatus: this.oldStatusId,
                        clientId: this.clientId,
                        support_group: this.currentGroup,
                        ticketTypeId: this.typeChecked
                    };

                    // if (this.statusSeq === 1 && Number(this.userSelected) !== Number(this.messageService.getUserId())) {
                    //     alert(this.messageService.CHANGE_STATUS);
                    // } else {
                    // alert(this.messageService.CHANGE_STATUS);
                    if (this.supportGroupSelected > 0) {
                        data['selected'] = 1;
                        this.dataLoaded = false;
                        this._rest.updateForwardedTicket(data).subscribe((res1) => {
                            this.respObject = res1;
                            // // console.log(JSON.stringify(this.respObject));
                            this.dataLoaded = true;
                            if (this.respObject.success) {
                                if (this.isViewTicket) {
                                    this.folderClick(this.folderClicked);
                                }
                                alert('Request Forwarded successfully');
                                this.terminateWorker();
                                this.modalReference.close();
                            } else {
                                alert(this.respObject.errorMessage);
                            }
                        }, (err) => {
                            // alert(this.messageService.SERVER_ERROR);
                        });
                    } else {
                        if (this.solProvided) {
                            data['selected'] = 0;
                            // data['refer_user_id'] = 0;
                            data['refer_user_id'] = null;
                            this.dataLoaded = false;
                            this._rest.updateForwardedTicket(data).subscribe((res1) => {
                                this.respObject = res1;
                                this.dataLoaded = true;
                                // // console.log(JSON.stringify(this.respObject));
                                if (this.respObject.success) {
                                    if (this.isViewTicket) {
                                        this.folderClick(this.folderClicked);
                                    }
                                    alert('Request Forwarded successfully');
                                    // if (this.slaTime) {
                                    //   clearInterval(this.slaTime);
                                    // }
                                    this.terminateWorker();
                                    this.modalReference.close();
                                } else {
                                    alert(this.respObject.errorMessage);
                                }
                            }, (err) => {
                                // alert(this.messageService.SERVER_ERROR);
                            });
                        } else {
                            alert('Workflow End. Please select support group if you want to forward the ticket');
                        }
                    }
                }
            }
        }
    }

    handleSelectedRowsChanged1(e, args) {
        if (Array.isArray(args.rows)) {
            this.selectedTitles = args.rows.map(idx => {
                const item = this.gridObj1.getDataItem(idx);
                return item || '';
            });
        }
    }

    handleSelectedRowsChanged2(e, args) {
        if (Array.isArray(args.rows)) {
            this.selectedTitles2 = args.rows.map(idx => {
                const item = this.gridObj2.getDataItem(idx);
                return item || '';
            });

        }
    }

    getSLAPercentage() {
        this._rest.getSLA(this.tId, this.messageService.getUserId()).subscribe((res) => {
            this.respObject = res;
            // // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
                const slaTicketId = this.respObject.details.ticketId;
                if (Number(this.tId) === Number(slaTicketId)) {
                    this.percent = this.respObject.details.completedSlaPercentage;
                    this.respPercent = this.respObject.details.completedSlaResponsePercentage;
                    // // // console.log(typeof this.percent);
                    this.resolution_status = this.respObject.details.resolution_status;
                    this.reponse_status = this.respObject.details.reponse_status;
                    if (Number(this.percent) >= 100) {
                        this.slaString = 'YES';
                        this.slaViolated = true;
                        this.outerColor = '#F70E0B';
                        this.innerColor = '#AF1D1B';
                        // clearInterval(this.slaTime);
                        this.terminateWorker();
                    } else {
                        this.outerColor = '#78C000';
                        this.slaString = 'NO';
                        this.innerColor = '#C7E596';
                    }
                    if (this.resolution_status === 'N') {
                        this.resoClockStatus = 'Running';
                        this.resolutionStatus = true;
                    } else {
                        this.resoClockStatus = 'Stop';
                        this.resolutionStatus = false;
                    }
                    if (Number(this.respPercent) >= 100) {
                        this.slaStringResp = 'YES';
                        this.slaViolatedResp = true;
                        this.outerColorResp = '#F70E0B';
                        this.innerColorResp = '#AF1D1B';
                    } else {
                        this.outerColorResp = '#78C000';
                        this.slaStringResp = 'NO';
                        this.innerColorResp = '#C7E596';
                    }
                    if (this.reponse_status === 'N') {
                        this.respClockStatus = 'Running';
                        this.reponseStatus = true;
                    } else {
                        this.respClockStatus = 'Stop';
                        this.reponseStatus = false;
                    }
                }
            } else {
                alert(this.respObject.errorMessage);
            }
        }, (err) => {
            // alert(this.messageService.SERVER_ERROR);
        });
    }

    folderClick(value) {
        // // console.log('clicked: ' + value, this.typeChecked, this.userGroupId);
        this.messageService.masterCloseModalSubject.next(value);
    }

    getGroup() {
        this._rest.getSupportGroupByCategory1(this.clientId, this.lastCatId, this.gid, this.typeChecked, this.tId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.respObject.details.gr.unshift({ id: 0, name: 'Select Group' });
                this.groups = this.respObject.details.gr;
                this.wGroups = this.respObject.details.wGr;
                // this.checkCanAddSolution();
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    getUser(groupId) {
        if (this.messageService.getUserId() != this.aid) {
            this._rest.getUserByGroupCHR(this.clientId, groupId, this.FinalCatgory).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    // // // console.log(JSON.stringify(this.respObject));
                    this.respObject.details.unshift({ id: 0, name: 'Select User' });
                    this.users = this.respObject.details;
                    console.log('users ' + JSON.stringify(this.users));
                    //  let UserId = Number(this.messageService.getUserId());
                    //     console.log (UserId);
                    //     for(let i = 0; i <= this.users.length-1 ; i++){
                    //         if(UserId === this.users[i].id){
                    //             console.log(this.users[i].name);
                    //             console.log('kkkkkkkkkkkkk');
                    //         }
                    //     }
                    if (this.baseUser) {
                        this.users_copy = this.respObject.details;
                        this.baseUser = false;
                    }
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // alert(this.messageService.SERVER_ERROR);
            });
        } else {
            console.log('llllllllllllllllllllllllll ' + this.aid);
            this._rest.getUserByGroup1CHR(this.clientId, groupId, this.FinalCatgory, this.aid, this.messageService.getUserId()).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    // // // console.log(JSON.stringify(this.respObject));
                    this.respObject.details.unshift({ id: 0, name: 'Select User' });
                    this.users = this.respObject.details;
                    console.log('users ' + JSON.stringify(this.users));
                    // let UserId = Number(this.messageService.getUserId());
                    // for(let i = 0; i <= this.users.length-1 ; i++){
                    //     if(UserId === this.users[i].id){
                    //         console.log(this.users[i].name);
                    //         console.log('lllllllllllllllll');
                    //     }
                    // }
                    //    console.log (UserId);
                    if (this.baseUser) {
                        this.users_copy = this.respObject.details;
                        this.baseUser = false;
                    }
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // alert(this.messageService.SERVER_ERROR);
            });
        }
    }

    onUpload(data: any) {
        this.dataLoaded = data.loader;
    }

    onGroupChange() {
        this.getUser(this.supportGroupSelected);
        // if (this.groupDetails) {
        this.userSelected = 0;
        // } else {
        //   this.userSelected = this.aid;
        // }
        this.currentUser = 'No User Assigned';
        // // console.log('groupChange: ' + this.supportGroupSelected);
    }

    displayTicket(res1) {
        this.respObject = res1;
        if (this.respObject.success) {
            // // // console.log(JSON.stringify(this.respObject));
            // this.types = this.respObject.details;
            for (let i = 0; i < this.respObject.details.length; i++) {
                // if (this.respObject.details[i].id === 51) {
                //     // // console.log(new Date(this.respObject.details[i].createdSince));
                // }
                this.respObject.details[i].createdSince =
                    this.messageService.datePipeFunc(this.respObject.details[i].createdSince);
                this.respObject.details[i].dDate =
                    this.messageService.datePipeFunc(this.respObject.details[i].dDate);
                this.respObject.details[i].updateDate =
                    this.messageService.datePipeFunc(this.respObject.details[i].updateDate);
                if (this.respObject.details[i].ticketCloseDate === undefined || this.respObject.details[i].ticketCloseDate === '' ||
                    this.respObject.details[i].ticketCloseDate === null) {
                    this.respObject.details[i].ticketCloseDate = '';
                } else {
                    this.respObject.details[i].ticketCloseDate =
                        this.messageService.datePipeFunc(this.respObject.details[i].ticketCloseDate);
                }
                this.respObject.details[i].requestedDate =
                    this.messageService.datePipeFunc(this.respObject.details[i].requestedDate);
            }
            this.dataset = this.respObject.details;
            this.getTableData();
            this.totalItems = this.dataset.length;
            // // // console.log('this.seq:5' + this.seq);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }

    getTableData() {
        this.tabledata.emit({ 'dataset': this.dataset });
    }

    ticketSearch() {
        this.search.emit();
    }

    viewPageload() {
        this.loadView.emit();
    }

    onmessage(): void {
        this.worker.onmessage = (data: any) => {
            // // // console.log(data.data.result, typeof data.data.result);
            this.respObject = JSON.parse(data.data.result);
            // // // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
                const slaTicketId = this.respObject.details.ticketId;
                if (Number(this.tId) === Number(slaTicketId)) {
                    this.percent = this.respObject.details.completedSlaPercentage;
                    this.respPercent = this.respObject.details.completedSlaResponsePercentage;
                    this.resolution_status = this.respObject.details.resolution_status;
                    this.reponse_status = this.respObject.details.reponse_status;
                    if (Number(this.percent) >= 100) {
                        this.slaString = 'YES';
                        this.slaViolated = true;
                        this.outerColor = '#F70E0B';
                        this.innerColor = '#AF1D1B';
                        // clearInterval(this.slaTime);
                        this.terminateWorker();
                    } else {
                        this.outerColor = '#78C000';
                        this.slaString = 'NO';
                        this.innerColor = '#C7E596';
                    }
                    if (this.resolution_status === 'N') {
                        this.resoClockStatus = 'Running';
                        this.resolutionStatus = true;
                    } else {
                        this.resoClockStatus = 'Stop';
                        this.resolutionStatus = false;
                    }
                    if (Number(this.respPercent) >= 100) {
                        this.slaStringResp = 'YES';
                        this.slaViolatedResp = true;
                        this.outerColorResp = '#F70E0B';
                        this.innerColorResp = '#AF1D1B';
                    } else {
                        this.outerColorResp = '#78C000';
                        this.slaStringResp = 'NO';
                        this.innerColorResp = '#C7E596';
                    }
                    if (this.reponse_status === 'N') {
                        this.respClockStatus = 'Running';
                        this.reponseStatus = true;
                    } else {
                        this.respClockStatus = 'Stop';
                        this.reponseStatus = false;
                    }
                }
            } else {
                alert(this.respObject.errorMessage);
            }
        };
    }

    ngOnDestroy(): void {
        if (this.commentSubscribe) {
            this.commentSubscribe.unsubscribe();
        }
        if (this.closeModalSubscribe) {
            this.closeModalSubscribe.unsubscribe();
        }
        if (this.attachmentSubscribe) {
            this.attachmentSubscribe.unsubscribe();
        }
        if (this.solSubscribe) {
            this.solSubscribe.unsubscribe();
        }
        if (this.modalSubscribe) {
            this.modalSubscribe.unsubscribe();
        }
    }

    onFileAttach() {
        this.attachFile = this.attachFile + 1;
    }

    onRemove() {
        this.attachFile = this.attachFile - 1;
    }

    downloadFile(attachedFilePath: any) {
        this._rest.downloadFile(this.clientId, encodeURIComponent(attachedFilePath), 'ticket').subscribe((res: any) => {
            if (res.success) {
                window.location.href = res.value;
            } else {
                alert(res.errorMessage);
            }
        }, (err) => {
        });
    }
}

@Component({
    template: `
        <div class="csat modal-header modalTitle1">
            <div class="modal-title">{{header}}</div>
        </div>
        <div class="csat modal-body modal-height pad-top-0">
            <div class="loader" [hidden]="closeLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif">
            </div>
            <div class="form-group">
                <input type="text" class="form-control radius-0 font-13 csat-question" [(ngModel)]="question"
                       [disabled]="true"
                       placeholder="Question">
            </div>
            <div class="rating">
                <mat-radio-group class="csat_rating" (change)="onButtonChange($event)">
                    <mat-radio-button class="ratingEmoji" *ngFor="let raring of values;" [value]="raring.id">
                        <img src="../../../assets/img/{{raring.image}}" title="{{raring.csatRating}}" height="50"
                             width="50">
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="form-group">
                <textarea class="form-control radius-0 font-13 csat_comment" [(ngModel)]="comment"
                          placeholder="Comment"></textarea>
            </div>
            <!--<div class="form-group" *ngIf="type==='csat'">-->
            <!--<select class="form-control radius-0 font-13 " [(ngModel)]="valSelected">-->
            <!--<option *ngFor="let opt of values" [value]="opt.id">{{opt.value}}</option>-->
            <!--</select>-->
            <!--</div>-->
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success radius-0" *ngIf="type==='approve'" (click)="approve('1')">
                Approve & Close
            </button>
            <button type="button" class="btn btn-danger radius-0" *ngIf="type==='approve'" (click)="approve('0')">Reject
                & Close
            </button>
            <button type="button" class="btn btn-success radius-0" *ngIf="type==='csat'" (click)="save()"
                    [disabled]="saveDisable">Save &
                Close
            </button>
            <button type="button" class="btn btn-danger radius-0" *ngIf="type==='csat'"
                    (click)="activeModal.close('Close click')">Cancel
            </button>
        </div>
    `
})
export class CSATmodalCHRComponent implements OnInit {
    comment: string;
    values = [];
    valSelected: number;
    @Input() id;
    @Input() user_id;
    @Input() ticketId;
    @Input() type;
    @Input() cat_id;
    @Input() parent_cat_id;
    @Input() groupId;
    @Input() selectedUserID;
    @Input() header;
    @Input() seq;
    @Input() client_id;
    @Input() typeChecked;
    closeLoaded: boolean;
    saveDisable: boolean;
    question: string;
    dissatisfiedRating = 4;
    veryDissatisfiedRating = 5;
    Rating: number;

    private respObject: any;

    constructor(public activeModal: NgbActiveModal, private _rest: RestApiService, private messageService: MessageService) {

    }

    ngOnInit(): void {
        this.valSelected = 0;
        this.closeLoaded = true;
        this.saveDisable = false;
        this.comment = '';

        if (this.type === 'csat') {
            this._rest.getCsatRatingList(this.client_id).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    // this.respObject.details.unshift({id: 0, name: 'Select Rating'});
                    this.values = this.respObject.details;
                    // console.log('ratinggggggggggggggggggggggggg===' + JSON.stringify(this.values));
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // alert(this.messageService.SERVER_ERROR);
            });

            this._rest.getCsatQuestion(this.client_id).subscribe((res1) => {
                this.respObject = res1;
                if (this.respObject.success) {
                    this.question = this.respObject.details[0].question;
                    // console.log('questionsssssssssssssssss===' + JSON.stringify(this.question));
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // alert(this.messageService.SERVER_ERROR);
            });
        }
    }

    onButtonChange(value) {
        this.valSelected = value.value;
        for (let i = 0; i <= this.values.length - 1; i++) {
            if (this.values[i].id === this.valSelected) {
                this.Rating = this.values[i].ratingValue;
            }
        }
    }

    save() {
        const data = {
            comm: this.comment,
            scrore: this.valSelected,
            id: this.id,
            ticketId: this.ticketId,
            user_id: this.user_id,
            ticket_type_seq: this.seq,
            supportGroupLevelId: this.groupId
        };
        this.closeLoaded = false;
        this.saveDisable = true;
        if (this.valSelected !== 0) {
            if ((this.Rating === this.dissatisfiedRating && this.comment === '') || (this.Rating === this.veryDissatisfiedRating && this.comment === '')) {
                alert('Please enter comment before closing the ticket');
                this.closeLoaded = true;
                this.saveDisable = false;
            } else {
                this._rest.updateTicketStatusWithClose(data).subscribe((res1) => {
                    this.respObject = res1;
                    // // console.log(JSON.stringify(this.respObject));
                    if (this.respObject.success) {
                        this.closeLoaded = true;
                        alert('Ticket Closed Successfully');
                        // this.statusName = this.status[this.statusIndex].name;
                        this.activeModal.close();
                        this.messageService.closeModalSubject.next('close');
                    } else {
                        alert(this.respObject.errorMessage);
                        this.closeLoaded = true;
                    }
                }, (err) => {
                    // alert(this.messageService.SERVER_ERROR);
                });
            }
        } else {
            alert(this.messageService.CSAT_RATING);
            this.closeLoaded = true;
            this.saveDisable = false;
        }
    }

    approve(isApproved) {
        // // console.log(this.comment);
        if (this.comment === undefined || this.comment === '') {
            alert(this.messageService.BLANK_COMMENT);
        } else {
            const data = {
                id: this.ticketId,
                supportGroupLevelId: this.groupId,
                createdBy: this.user_id,
                refer_user_id: this.selectedUserID,
                cat_id: this.cat_id,
                parent_cat_id: this.parent_cat_id,
                WFCClientResultId: this.id,
                appr_remarks: this.comment,
                isApproveTicket: isApproved,
                ticketTypeId: this.typeChecked,
                clientId: this.client_id
            };
            // // console.log(JSON.stringify(data));
            this._rest.approveProblemTicket(data).subscribe((res) => {
                this.respObject = res;
                // // // console.log(JSON.stringify(this.respObject))
                if (this.respObject.success) {
                    this.activeModal.close();
                    this.messageService.closeModalSubject.next('approve');
                } else {
                    alert(this.respObject.errorMessage);
                }
            }, (err) => {
                // alert(this.messageService.SERVER_ERROR);
            });
        }
    }
}
